module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01a6":
/***/ (function(module, exports) {

module.exports = require("vue-property-decorator");

/***/ }),

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0a49":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("9b43");
var IObject = __webpack_require__("626a");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var asc = __webpack_require__("cd1c");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1169":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("2d95");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "11e9":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("52a7");
var createDesc = __webpack_require__("4630");
var toIObject = __webpack_require__("6821");
var toPrimitive = __webpack_require__("6a99");
var has = __webpack_require__("69a8");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("9e1e") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "1991":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var invoke = __webpack_require__("31f4");
var html = __webpack_require__("fab2");
var cel = __webpack_require__("230e");
var global = __webpack_require__("7726");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("2d95")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "1fa8":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("cb7c");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "20d6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__("5ca1");
var $find = __webpack_require__("0a49")(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("9c6c")(KEY);


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "2350":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "2397":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__("5ca1");
var create = __webpack_require__("2aeb");
var aFunction = __webpack_require__("d8e8");
var anObject = __webpack_require__("cb7c");
var isObject = __webpack_require__("d3f4");
var fails = __webpack_require__("79e5");
var bind = __webpack_require__("f0c1");
var rConstruct = (__webpack_require__("7726").Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "27ee":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("23c6");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var Iterators = __webpack_require__("84f2");
module.exports = __webpack_require__("8378").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "28a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__("aae3");
var anObject = __webpack_require__("cb7c");
var speciesConstructor = __webpack_require__("ebd6");
var advanceStringIndex = __webpack_require__("0390");
var toLength = __webpack_require__("9def");
var callRegExpExec = __webpack_require__("5f1b");
var regexpExec = __webpack_require__("520a");
var fails = __webpack_require__("79e5");
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__("214f")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "31f4":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "33a4":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("84f2");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "36bd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__("4bf8");
var toAbsoluteIndex = __webpack_require__("77f1");
var toLength = __webpack_require__("9def");
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "3846":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("9e1e") && /./g.flags != 'g') __webpack_require__("86cc").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("0bfb")
});


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4a59":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var call = __webpack_require__("1fa8");
var isArrayIter = __webpack_require__("33a4");
var anObject = __webpack_require__("cb7c");
var toLength = __webpack_require__("9def");
var getIterFn = __webpack_require__("27ee");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "4f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("c26b");
var validate = __webpack_require__("b39a");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("e0b8")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "504c":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("9e1e");
var getKeys = __webpack_require__("0d58");
var toIObject = __webpack_require__("6821");
var isEnum = __webpack_require__("52a7").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5389":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MapSearch_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("86e1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MapSearch_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MapSearch_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MapSearch_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "551c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var global = __webpack_require__("7726");
var ctx = __webpack_require__("9b43");
var classof = __webpack_require__("23c6");
var $export = __webpack_require__("5ca1");
var isObject = __webpack_require__("d3f4");
var aFunction = __webpack_require__("d8e8");
var anInstance = __webpack_require__("f605");
var forOf = __webpack_require__("4a59");
var speciesConstructor = __webpack_require__("ebd6");
var task = __webpack_require__("1991").set;
var microtask = __webpack_require__("8079")();
var newPromiseCapabilityModule = __webpack_require__("a5b8");
var perform = __webpack_require__("9c80");
var userAgent = __webpack_require__("a25f");
var promiseResolve = __webpack_require__("bcaa");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("2b4c")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("dcbc")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("7f20")($Promise, PROMISE);
__webpack_require__("7a56")(PROMISE);
Wrapper = __webpack_require__("8378")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("5cc5")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5880":
/***/ (function(module, exports) {

module.exports = require("vuex");

/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5cc5":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("2b4c")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "5dbc":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var setPrototypeOf = __webpack_require__("8b97").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "5df3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("02f4")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("01f9")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "67ab":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("ca5a")('meta');
var isObject = __webpack_require__("d3f4");
var has = __webpack_require__("69a8");
var setDesc = __webpack_require__("86cc").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("79e5")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "6b54":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("3846");
var anObject = __webpack_require__("cb7c");
var $flags = __webpack_require__("0bfb");
var DESCRIPTORS = __webpack_require__("9e1e");
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__("2aba")(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__("79e5")(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ "6c7b":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__("5ca1");

$export($export.P, 'Array', { fill: __webpack_require__("36bd") });

__webpack_require__("9c6c")('fill');


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7a56":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var dP = __webpack_require__("86cc");
var DESCRIPTORS = __webpack_require__("9e1e");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "7f7f":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("9e1e") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "8079":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var macrotask = __webpack_require__("1991").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("2d95")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "86e1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8904");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0b4d51a1", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8904":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".location-search-control{z-index:2}.asset-search .multiselect__option{padding:4px}.map-search{position:relative;top:-64px;-webkit-transition:top .5s;transition:top .5s;-webkit-transform:translateZ(0);transform:translateZ(0);pointer-events:all}.map-search.show-map-search{top:0}.map-search .multiselect__tags{padding-top:0}.map-search .multiselect__placeholder{margin-top:6px;margin-bottom:4px;text-overflow:ellipsis;max-height:20px;overflow:hidden}.map-search .multiselect__content-wrapper{z-index:6;position:fixed;width:100%}.map-search .multiselect{z-index:10}.map-search .alert{padding-right:1.25rem;margin-bottom:0}.map-search .alert,.map-search .alert-addon{border-top-left-radius:0;border-top-right-radius:0}.map-search .expand-grip{width:105px;margin-left:35px;position:relative;z-index:1}.map-search .expand-grip span{position:absolute;z-index:5;top:0;left:20px;pointer-events:none}.map-search .expand-grip .trapezoid{height:30px;-webkit-perspective-origin:top;perspective-origin:bottom;-webkit-transform:perspective(10px) rotateX(-10deg);transform:perspective(10px) rotateX(-10deg);cursor:pointer}", ""]);

// exports


/***/ }),

/***/ "8b97":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("d3f4");
var anObject = __webpack_require__("cb7c");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("9b43")(Function.call, __webpack_require__("11e9").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "8e5f":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():undefined}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=60)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var i=n(49)("wks"),r=n(30),o=n(0).Symbol,s="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=s&&o[t]||(s?o:r)("Symbol."+t))}).store=i},function(t,e,n){var i=n(5);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var i=n(0),r=n(10),o=n(8),s=n(6),u=n(11),a=function(t,e,n){var l,c,f,p,h=t&a.F,d=t&a.G,v=t&a.S,g=t&a.P,y=t&a.B,m=d?i:v?i[e]||(i[e]={}):(i[e]||{}).prototype,b=d?r:r[e]||(r[e]={}),_=b.prototype||(b.prototype={});d&&(n=e);for(l in n)c=!h&&m&&void 0!==m[l],f=(c?m:n)[l],p=y&&c?u(f,i):g&&"function"==typeof f?u(Function.call,f):f,m&&s(m,l,f,t&a.U),b[l]!=f&&o(b,l,p),g&&_[l]!=f&&(_[l]=f)};i.core=r,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var i=n(0),r=n(8),o=n(12),s=n(30)("src"),u=Function.toString,a=(""+u).split("toString");n(10).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var l="function"==typeof n;l&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(l&&(o(n,s)||r(n,s,t[e]?""+t[e]:a.join(String(e)))),t===i?t[e]=n:u?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||u.call(this)})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(13),r=n(25);t.exports=n(4)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(14);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var i=n(2),r=n(41),o=n(29),s=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=n(7);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var i=n(23),r=n(16);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(53),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){var i=n(11),r=n(23),o=n(28),s=n(19),u=n(64);t.exports=function(t,e){var n=1==t,a=2==t,l=3==t,c=4==t,f=6==t,p=5==t||f,h=e||u;return function(e,u,d){for(var v,g,y=o(e),m=r(y),b=i(u,d,3),_=s(m.length),x=0,w=n?h(e,_):a?h(e,0):void 0;_>x;x++)if((p||x in m)&&(v=m[x],g=b(v,x,y),t))if(n)w[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:w.push(v)}else if(c)return!1;return f?-1:l||c?c:w}}},function(t,e,n){var i=n(5),r=n(0).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var i=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){t.exports=!1},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var i=n(13).f,r=n(12),o=n(1)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){var i=n(49)("keys"),r=n(30);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(16);t.exports=function(t){return Object(i(t))}},function(t,e,n){var i=n(5);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e,n){"use strict";var i=n(0),r=n(12),o=n(9),s=n(67),u=n(29),a=n(7),l=n(77).f,c=n(45).f,f=n(13).f,p=n(51).trim,h=i.Number,d=h,v=h.prototype,g="Number"==o(n(44)(v)),y="trim"in String.prototype,m=function(t){var e=u(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():p(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var s,a=e.slice(2),l=0,c=a.length;l<c;l++)if((s=a.charCodeAt(l))<48||s>r)return NaN;return parseInt(a,i)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(g?a(function(){v.valueOf.call(n)}):"Number"!=o(n))?s(new d(m(e)),n,h):m(e)};for(var b,_=n(4)?l(d):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;_.length>x;x++)r(d,b=_[x])&&!r(h,b)&&f(h,b,c(d,b));h.prototype=v,v.constructor=h,n(6)(i,"Number",h)}},function(t,e,n){"use strict";function i(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function r(t){return function(){return!t.apply(void 0,arguments)}}function o(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function s(t,e,n,i){return t.filter(function(t){return o(i(t,n),e)})}function u(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(n){return n.reduce(function(n,i){return i[t]&&i[t].length?(n.push({$groupLabel:i[e],$isLabel:!0}),n.concat(i[t])):n},[])}}function l(t,e,i,r,o){return function(u){return u.map(function(u){var a;if(!u[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var l=s(u[i],t,e,o);return l.length?(a={},n.i(d.a)(a,r,u[r]),n.i(d.a)(a,i,l),a):[]})}}var c=n(59),f=n(54),p=(n.n(f),n(95)),h=(n.n(p),n(31)),d=(n.n(h),n(58)),v=n(91),g=(n.n(v),n(98)),y=(n.n(g),n(92)),m=(n.n(y),n(88)),b=(n.n(m),n(97)),_=(n.n(b),n(89)),x=(n.n(_),n(96)),w=(n.n(x),n(93)),S=(n.n(w),n(90)),O=(n.n(S),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return function(t){return e.reduce(function(t,e){return e(t)},t)}});e.a={data:function(){return{search:"",isOpen:!1,preferredOpenDirection:"below",optimizedHeight:this.maxHeight}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return i(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},tagPosition:{type:String,default:"top"},max:{type:[Number,Boolean],default:!1},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},groupSelect:{type:Boolean,default:!1},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1},preselectFirst:{type:Boolean,default:!1}},mounted:function(){!this.multiple&&this.max&&console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."),this.preselectFirst&&!this.internalValue.length&&this.options.length&&this.select(this.filteredOptions[0])},computed:{internalValue:function(){return this.value||0===this.value?Array.isArray(this.value)?this.value:[this.value]:[]},filteredOptions:function(){var t=this.search||"",e=t.toLowerCase().trim(),n=this.options.concat();return n=this.internalSearch?this.groupValues?this.filterAndFlat(n,e,this.label):s(n,e,this.label,this.customLabel):this.groupValues?a(this.groupValues,this.groupLabel)(n):n,n=this.hideSelected?n.filter(r(this.isSelected)):n,this.taggable&&e.length&&!this.isExistingOption(e)&&("bottom"===this.tagPosition?n.push({isTag:!0,label:t}):n.unshift({isTag:!0,label:t})),n.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue.length?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(){this.resetAfter&&this.internalValue.length&&(this.search="",this.$emit("input",this.multiple?[]:null))},search:function(){this.$emit("search-change",this.search,this.id)}},methods:{getValue:function(){return this.multiple?this.internalValue:0===this.internalValue.length?null:this.internalValue[0]},filterAndFlat:function(t,e,n){return O(l(e,n,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return O(a(this.groupValues,this.groupLabel),u)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isOptionDisabled:function(t){return!!t.$isDisabled},getOptionLabel:function(t){if(i(t))return"";if(t.isTag)return t.label;if(t.$isLabel)return t.$groupLabel;var e=this.customLabel(t,this.label);return i(e)?"":e},select:function(t,e){if(t.$isLabel&&this.groupSelect)return void this.selectGroup(t);if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isDisabled||t.$isLabel)&&(!this.max||!this.multiple||this.internalValue.length!==this.max)&&("Tab"!==e||this.pointerDirty)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.$emit("select",t,this.id),this.multiple?this.$emit("input",this.internalValue.concat([t]),this.id):this.$emit("input",t,this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},selectGroup:function(t){var e=this,n=this.options.find(function(n){return n[e.groupLabel]===t.$groupLabel});if(n)if(this.wholeGroupSelected(n)){this.$emit("remove",n[this.groupValues],this.id);var i=this.internalValue.filter(function(t){return-1===n[e.groupValues].indexOf(t)});this.$emit("input",i,this.id)}else{var r=n[this.groupValues].filter(function(t){return!(e.isOptionDisabled(t)||e.isSelected(t))});this.$emit("select",r,this.id),this.$emit("input",this.internalValue.concat(r),this.id)}},wholeGroupSelected:function(t){var e=this;return t[this.groupValues].every(function(t){return e.isSelected(t)||e.isOptionDisabled(t)})},wholeGroupDisabled:function(t){return t[this.groupValues].every(this.isOptionDisabled)},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled&&!t.$isDisabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===n.i(c.a)(t)?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);if(this.$emit("remove",t,this.id),this.multiple){var r=this.internalValue.slice(0,i).concat(this.internalValue.slice(i+1));this.$emit("input",r,this.id)}else this.$emit("input",null,this.id);this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.internalValue.length&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.preferredOpenDirection="below",this.optimizedHeight=Math.min(e-40,this.maxHeight)):(this.preferredOpenDirection="above",this.optimizedHeight=Math.min(t-40,this.maxHeight))}}}}},function(t,e,n){"use strict";var i=n(54),r=(n.n(i),n(31));n.n(r);e.a={data:function(){return{pointer:0,pointerDirty:!1}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight},visibleElements:function(){return this.optimizedHeight/this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()},isOpen:function(){this.pointerDirty=!1}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},groupHighlight:function(t,e){var n=this;if(!this.groupSelect)return["multiselect__option--group","multiselect__option--disabled"];var i=this.options.find(function(t){return t[n.groupLabel]===e.$groupLabel});return i&&!this.wholeGroupDisabled(i)?["multiselect__option--group",{"multiselect__option--highlight":t===this.pointer&&this.showPointer},{"multiselect__option--group-selected":this.wholeGroupSelected(i)}]:"multiselect__option--disabled"},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-(this.visibleElements-1)*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()),this.pointerDirty=!0},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerBackward()):this.filteredOptions[this.pointer]&&this.filteredOptions[0].$isLabel&&!this.groupSelect&&this.pointerForward(),this.pointerDirty=!0},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0),this.filteredOptions.length>0&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()},pointerSet:function(t){this.pointer=t,this.pointerDirty=!0}}}},function(t,e,n){"use strict";var i=n(36),r=n(74),o=n(15),s=n(18);t.exports=n(72)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i=n(31),r=(n.n(i),n(32)),o=n(33);e.a={name:"vue-multiselect",mixins:[r.a,o.a],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectGroupLabel:{type:String,default:"Press enter to select group"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},deselectGroupLabel:{type:String,default:"Press enter to deselect group"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and ".concat(t," more")}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoOptions:{type:Boolean,default:!0},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{isSingleLabelVisible:function(){return(this.singleValue||0===this.singleValue)&&(!this.isOpen||!this.searchable)&&!this.visibleValues.length},isPlaceholderVisible:function(){return!(this.internalValue.length||this.searchable&&this.isOpen)},visibleValues:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},singleValue:function(){return this.internalValue[0]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},deselectGroupLabelText:function(){return this.showLabels?this.deselectGroupLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectGroupLabelText:function(){return this.showLabels?this.selectGroupLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.searchable||this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"100%"}:{width:"0",position:"absolute",padding:"0"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.preferredOpenDirection},showSearchInput:function(){return this.searchable&&(!this.hasSingleSelectedSlot||!this.visibleSingleValue&&0!==this.visibleSingleValue||this.isOpen)}}}},function(t,e,n){var i=n(1)("unscopables"),r=Array.prototype;void 0==r[i]&&n(8)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){var i=n(18),r=n(19),o=n(85);t.exports=function(t){return function(e,n,s){var u,a=i(e),l=r(a.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if((u=a[c++])!=u)return!0}else for(;l>c;c++)if((t||c in a)&&a[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(9),r=n(1)("toStringTag"),o="Arguments"==i(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),r))?n:o?i(e):"Object"==(u=i(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){"use strict";var i=n(2);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var i=n(0).document;t.exports=i&&i.documentElement},function(t,e,n){t.exports=!n(4)&&!n(7)(function(){return 7!=Object.defineProperty(n(21)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var i=n(9);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(14);t.exports.f=function(t){return new i(t)}},function(t,e,n){var i=n(2),r=n(76),o=n(22),s=n(27)("IE_PROTO"),u=function(){},a=function(){var t,e=n(21)("iframe"),i=o.length;for(e.style.display="none",n(40).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;i--;)delete a.prototype[o[i]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=i(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:r(n,e)}},function(t,e,n){var i=n(79),r=n(25),o=n(18),s=n(29),u=n(12),a=n(41),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=o(t),e=s(e,!0),a)try{return l(t,e)}catch(t){}if(u(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){var i=n(12),r=n(18),o=n(37)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,u=r(t),a=0,l=[];for(n in u)n!=s&&i(u,n)&&l.push(n);for(;e.length>a;)i(u,n=e[a++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(22);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(2),r=n(5),o=n(43);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var i=n(10),r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(24)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var i=n(2),r=n(14),o=n(1)("species");t.exports=function(t,e){var n,s=i(t).constructor;return void 0===s||void 0==(n=i(s)[o])?e:r(n)}},function(t,e,n){var i=n(3),r=n(16),o=n(7),s=n(84),u="["+s+"]",a="​",l=RegExp("^"+u+u+"*"),c=RegExp(u+u+"*$"),f=function(t,e,n){var r={},u=o(function(){return!!s[t]()||a[t]()!=a}),l=r[t]=u?e(p):s[t];n&&(r[n]=l),i(i.P+i.F*u,"String",r)},p=f.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(l,"")),2&e&&(t=t.replace(c,"")),t};t.exports=f},function(t,e,n){var i,r,o,s=n(11),u=n(68),a=n(40),l=n(21),c=n(0),f=c.process,p=c.setImmediate,h=c.clearImmediate,d=c.MessageChannel,v=c.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};p&&h||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){u("function"==typeof t?t:Function(t),e)},i(g),g},h=function(t){delete y[t]},"process"==n(9)(f)?i=function(t){f.nextTick(s(m,t,1))}:v&&v.now?i=function(t){v.now(s(m,t,1))}:d?(r=new d,o=r.port2,r.port1.onmessage=b,i=s(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",b,!1)):i="onreadystatechange"in l("script")?function(t){a.appendChild(l("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(s(m,t,1),0)}),t.exports={set:p,clear:h}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){"use strict";var i=n(3),r=n(20)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(36)("find")},function(t,e,n){"use strict";var i,r,o,s,u=n(24),a=n(0),l=n(11),c=n(38),f=n(3),p=n(5),h=n(14),d=n(61),v=n(66),g=n(50),y=n(52).set,m=n(75)(),b=n(43),_=n(80),x=n(86),w=n(48),S=a.TypeError,O=a.process,L=O&&O.versions,k=L&&L.v8||"",P=a.Promise,T="process"==c(O),V=function(){},E=r=b.f,A=!!function(){try{var t=P.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(V,V)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(V)instanceof e&&0!==k.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),C=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},D=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,s,u=r?e.ok:e.fail,a=e.resolve,l=e.reject,c=e.domain;try{u?(r||(2==t._h&&$(t),t._h=1),!0===u?n=i:(c&&c.enter(),n=u(i),c&&(c.exit(),s=!0)),n===e.promise?l(S("Promise-chain cycle")):(o=C(n))?o.call(n,a,l):a(n)):l(i)}catch(t){c&&!s&&c.exit(),l(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&j(t)})}},j=function(t){y.call(a,function(){var e,n,i,r=t._v,o=N(t);if(o&&(e=_(function(){T?O.emit("unhandledRejection",r,t):(n=a.onunhandledrejection)?n({promise:t,reason:r}):(i=a.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=T||N(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},$=function(t){y.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),D(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=C(t))?m(function(){var i={_w:n,_d:!1};try{e.call(t,l(M,i,1),l(F,i,1))}catch(t){F.call(i,t)}}):(n._v=t,n._s=1,D(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};A||(P=function(t){d(this,P,"Promise","_h"),h(t),i.call(this);try{t(l(M,this,1),l(F,this,1))}catch(t){F.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(81)(P.prototype,{then:function(t,e){var n=E(g(this,P));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&D(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=l(M,t,1),this.reject=l(F,t,1)},b.f=E=function(t){return t===P||t===s?new o(t):r(t)}),f(f.G+f.W+f.F*!A,{Promise:P}),n(26)(P,"Promise"),n(83)("Promise"),s=n(10).Promise,f(f.S+f.F*!A,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!A),"Promise",{resolve:function(t){return w(u&&this===s?P:this,t)}}),f(f.S+f.F*!(A&&n(73)(function(t){P.all(t).catch(V)})),"Promise",{all:function(t){var e=this,n=E(e),i=n.resolve,r=n.reject,o=_(function(){var n=[],o=0,s=1;v(t,!1,function(t){var u=o++,a=!1;n.push(void 0),s++,e.resolve(t).then(function(t){a||(a=!0,n[u]=t,--s||i(n))},r)}),--s||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=E(e),i=n.reject,r=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(3),r=n(10),o=n(0),s=n(50),u=n(48);i(i.P+i.R,"Promise",{finally:function(t){var e=s(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";function i(t){n(99)}var r=n(35),o=n(101),s=n(100),u=i,a=s(r.a,o.a,!1,u,null,null);e.a=a.exports},function(t,e,n){"use strict";function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}e.a=i},function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t){return(r="function"==typeof Symbol&&"symbol"===i(Symbol.iterator)?function(t){return i(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":i(t)})(t)}e.a=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(34),r=(n.n(i),n(55)),o=(n.n(r),n(56)),s=(n.n(o),n(57)),u=n(32),a=n(33);n.d(e,"Multiselect",function(){return s.a}),n.d(e,"multiselectMixin",function(){return u.a}),n.d(e,"pointerMixin",function(){return a.a}),e.default=s.a},function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var i=n(14),r=n(28),o=n(23),s=n(19);t.exports=function(t,e,n,u,a){i(e);var l=r(t),c=o(l),f=s(l.length),p=a?f-1:0,h=a?-1:1;if(n<2)for(;;){if(p in c){u=c[p],p+=h;break}if(p+=h,a?p<0:f<=p)throw TypeError("Reduce of empty array with no initial value")}for(;a?p>=0:f>p;p+=h)p in c&&(u=e(u,c[p],p,l));return u}},function(t,e,n){var i=n(5),r=n(42),o=n(1)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var i=n(63);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(8),r=n(6),o=n(7),s=n(16),u=n(1);t.exports=function(t,e,n){var a=u(t),l=n(s,a,""[t]),c=l[0],f=l[1];o(function(){var e={};return e[a]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,c),i(RegExp.prototype,a,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}))}},function(t,e,n){var i=n(11),r=n(70),o=n(69),s=n(2),u=n(19),a=n(87),l={},c={},e=t.exports=function(t,e,n,f,p){var h,d,v,g,y=p?function(){return t}:a(t),m=i(n,f,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(h=u(t.length);h>b;b++)if((g=e?m(s(d=t[b])[0],d[1]):m(t[b]))===l||g===c)return g}else for(v=y.call(t);!(d=v.next()).done;)if((g=r(v,m,d.value,e))===l||g===c)return g};e.BREAK=l,e.RETURN=c},function(t,e,n){var i=n(5),r=n(82).set;t.exports=function(t,e,n){var o,s=e.constructor;return s!==n&&"function"==typeof s&&(o=s.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var i=n(15),r=n(1)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){var i=n(2);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(44),r=n(25),o=n(26),s={};n(8)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(s,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(24),r=n(3),o=n(6),s=n(8),u=n(15),a=n(71),l=n(26),c=n(78),f=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,g,y){a(n,e,d);var m,b,_,x=function(t){if(!p&&t in L)return L[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",S="values"==v,O=!1,L=t.prototype,k=L[f]||L["@@iterator"]||v&&L[v],P=k||x(v),T=v?S?x("entries"):P:void 0,V="Array"==e?L.entries||k:k;if(V&&(_=c(V.call(new t)))!==Object.prototype&&_.next&&(l(_,w,!0),i||"function"==typeof _[f]||s(_,f,h)),S&&k&&"values"!==k.name&&(O=!0,P=function(){return k.call(this)}),i&&!y||!p&&!O&&L[f]||s(L,f,P),u[e]=P,u[w]=h,v)if(m={values:S?P:x("values"),keys:g?P:x("keys"),entries:T},y)for(b in m)b in L||o(L,b,m[b]);else r(r.P+r.F*(p||O),e,m);return m}},function(t,e,n){var i=n(1)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],s=o[i]();s.next=function(){return{done:n=!0}},o[i]=function(){return s},t(o)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var i=n(0),r=n(52).set,o=i.MutationObserver||i.WebKitMutationObserver,s=i.process,u=i.Promise,a="process"==n(9)(s);t.exports=function(){var t,e,n,l=function(){var i,r;for(a&&(i=s.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(a)n=function(){s.nextTick(l)};else if(!o||i.navigator&&i.navigator.standalone)if(u&&u.resolve){var c=u.resolve(void 0);n=function(){c.then(l)}}else n=function(){r.call(i,l)};else{var f=!0,p=document.createTextNode("");new o(l).observe(p,{characterData:!0}),n=function(){p.data=f=!f}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){var i=n(13),r=n(2),o=n(47);t.exports=n(4)?Object.defineProperties:function(t,e){r(t);for(var n,s=o(e),u=s.length,a=0;u>a;)i.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var i=n(46),r=n(22).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){var i=n(12),r=n(28),o=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var i=n(6);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){var i=n(5),r=n(2),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(11)(Function.call,n(45).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(4),s=n(1)("species");t.exports=function(t){var e=i[t];o&&e&&!e[s]&&r.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var i=n(53),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(0),r=i.navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var i=n(38),r=n(1)("iterator"),o=n(15);t.exports=n(10).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(3),r=n(20)(2);i(i.P+i.F*!n(17)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(37)(!1),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(s||!n(17)(o)),"Array",{indexOf:function(t){return s?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){var i=n(3);i(i.S,"Array",{isArray:n(42)})},function(t,e,n){"use strict";var i=n(3),r=n(20)(1);i(i.P+i.F*!n(17)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(62);i(i.P+i.F*!n(17)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(6)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){n(4)&&"g"!=/./g.flags&&n(13).f(RegExp.prototype,"flags",{configurable:!0,get:n(39)})},function(t,e,n){n(65)("search",1,function(t,e,n){return[function(n){"use strict";var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(94);var i=n(2),r=n(39),o=n(4),s=/./.toString,u=function(t){n(6)(RegExp.prototype,"toString",t,!0)};n(7)(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?u(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=s.name&&u(function(){return s.call(this)})},function(t,e,n){"use strict";n(51)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){for(var i=n(34),r=n(47),o=n(6),s=n(0),u=n(8),a=n(15),l=n(1),c=l("iterator"),f=l("toStringTag"),p=a.Array,h={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=r(h),v=0;v<d.length;v++){var g,y=d[v],m=h[y],b=s[y],_=b&&b.prototype;if(_&&(_[c]||u(_,c,p),_[f]||u(_,f,y),a[y]=p,m))for(g in i)_[g]||o(_,g,i[g],!0)}},function(t,e){},function(t,e){t.exports=function(t,e,n,i,r,o){var s,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(s=t,u=t.default);var l="function"==typeof u?u.options:u;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),r&&(l._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=i),c){var f=l.functional,p=f?l.render:l.beforeCreate;f?(l._injectStyles=c,l.render=function(t,e){return c.call(e),p(t,e)}):l.beforeCreate=p?[].concat(p,c):[c]}return{esModule:s,exports:u,options:l}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.searchable?-1:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")||!t._k(e.keyCode,"tab",9,e.key,"Tab")?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()}}},[t._t("caret",[n("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})],{toggle:t.toggle}),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),n("div",{ref:"tags",staticClass:"multiselect__tags"},[t._t("selection",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValues.length>0,expression:"visibleValues.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValues,function(e,i){return[t._t("tag",[n("span",{key:i,staticClass:"multiselect__tag"},[n("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),n("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keypress:function(n){if(!("button"in n)&&t._k(n.keyCode,"enter",13,n.key,"Enter"))return null;n.preventDefault(),t.removeElement(e)},mousedown:function(n){n.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[t._t("limit",[n("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})])]:t._e()],{search:t.search,remove:t.removeElement,values:t.visibleValues,isOpen:t.isOpen}),t._v(" "),n("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?n("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"nope",placeholder:t.placeholder,disabled:t.disabled,tabindex:t.tabindex},domProps:{value:t.search},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"]))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"]))return null;e.preventDefault(),t.pointerBackward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46],e.key,["Backspace","Delete"]))return null;e.stopPropagation(),t.removeLastElement()}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}}}):t._e(),t._v(" "),t.isSingleLabelVisible?n("span",{staticClass:"multiselect__single",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("singleLabel",[[t._v(t._s(t.currentOptionLabel))]],{option:t.singleValue})],2):t._e(),t._v(" "),t.isPlaceholderVisible?n("span",{staticClass:"multiselect__placeholder",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("placeholder",[t._v("\n          "+t._s(t.placeholder)+"\n        ")])],2):t._e()],2),t._v(" "),n("transition",{attrs:{name:"multiselect"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},attrs:{tabindex:"-1"},on:{focus:t.activate,mousedown:function(t){t.preventDefault()}}},[n("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?n("li",[n("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,i){return n("li",{key:i,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():n("span",{staticClass:"multiselect__option",class:t.optionHighlight(i,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(n){n.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(i)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?n("span",{staticClass:"multiselect__option",class:t.groupHighlight(i,e),attrs:{"data-select":t.groupSelect&&t.selectGroupLabelText,"data-deselect":t.groupSelect&&t.deselectGroupLabelText},on:{mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.groupSelect&&t.pointerSet(i)},mousedown:function(n){n.preventDefault(),t.selectGroup(e)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")],{search:t.search})],2)]),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoOptions&&0===t.options.length&&!t.search&&!t.loading,expression:"showNoOptions && (options.length === 0 && !search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noOptions",[t._v("List is empty.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},r=[],o={render:i,staticRenderFns:r};e.a=o}])});

/***/ }),

/***/ "9093":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("ce10");
var hiddenKeys = __webpack_require__("e11e").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9c80":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a25f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "a5b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("d8e8");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "aa77":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("5ca1");
var defined = __webpack_require__("be13");
var fails = __webpack_require__("79e5");
var spaces = __webpack_require__("fdef");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "b39a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "bcaa":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var isObject = __webpack_require__("d3f4");
var newPromiseCapability = __webpack_require__("a5b8");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c26b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("86cc").f;
var create = __webpack_require__("2aeb");
var redefineAll = __webpack_require__("dcbc");
var ctx = __webpack_require__("9b43");
var anInstance = __webpack_require__("f605");
var forOf = __webpack_require__("4a59");
var $iterDefine = __webpack_require__("01f9");
var step = __webpack_require__("d53b");
var setSpecies = __webpack_require__("7a56");
var DESCRIPTORS = __webpack_require__("9e1e");
var fastKey = __webpack_require__("67ab").fastKey;
var validate = __webpack_require__("b39a");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c590":
/***/ (function(module, exports) {

module.exports = require("vuex-class");

/***/ }),

/***/ "c5f6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var has = __webpack_require__("69a8");
var cof = __webpack_require__("2d95");
var inheritIfRequired = __webpack_require__("5dbc");
var toPrimitive = __webpack_require__("6a99");
var fails = __webpack_require__("79e5");
var gOPN = __webpack_require__("9093").f;
var gOPD = __webpack_require__("11e9").f;
var dP = __webpack_require__("86cc").f;
var $trim = __webpack_require__("aa77").trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__("2aeb")(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__("9e1e") ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__("2aba")(global, NUMBER, $Number);
}


/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "cd1c":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("e853");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cebe":
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "dcbc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("2aba");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "e0b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var redefineAll = __webpack_require__("dcbc");
var meta = __webpack_require__("67ab");
var forOf = __webpack_require__("4a59");
var anInstance = __webpack_require__("f605");
var isObject = __webpack_require__("d3f4");
var fails = __webpack_require__("79e5");
var $iterDetect = __webpack_require__("5cc5");
var setToStringTag = __webpack_require__("7f20");
var inheritIfRequired = __webpack_require__("5dbc");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "e853":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var isArray = __webpack_require__("1169");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "ebd6":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("cb7c");
var aFunction = __webpack_require__("d8e8");
var SPECIES = __webpack_require__("2b4c")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "f0c1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("d8e8");
var isObject = __webpack_require__("d3f4");
var invoke = __webpack_require__("31f4");
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),

/***/ "f605":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "getScript", function() { return /* reexport */ getScript; });
__webpack_require__.d(__webpack_exports__, "GPSService", function() { return /* reexport */ gps_service; });
__webpack_require__.d(__webpack_exports__, "getEnhancedMapping", function() { return /* reexport */ getEnhancedMapping; });
__webpack_require__.d(__webpack_exports__, "getLatLngPolarity", function() { return /* reexport */ getLatLngPolarity; });
__webpack_require__.d(__webpack_exports__, "convertStringToLatLng", function() { return /* reexport */ convertStringToLatLng; });
__webpack_require__.d(__webpack_exports__, "stringToBounds", function() { return /* reexport */ stringToBounds; });
__webpack_require__.d(__webpack_exports__, "addMeterToCoord", function() { return /* reexport */ addMeterToCoord; });
__webpack_require__.d(__webpack_exports__, "union", function() { return /* reexport */ union; });
__webpack_require__.d(__webpack_exports__, "extend", function() { return /* reexport */ extend; });
__webpack_require__.d(__webpack_exports__, "MarkerTypes", function() { return /* reexport */ MarkerTypes; });
__webpack_require__.d(__webpack_exports__, "MarkerState", function() { return /* reexport */ markerTypes_MarkerState; });
__webpack_require__.d(__webpack_exports__, "MarkerStateMap", function() { return /* reexport */ markerTypes_MarkerStateMap; });
__webpack_require__.d(__webpack_exports__, "MarkerTypeLine", function() { return /* reexport */ markerTypes_MarkerTypeLine; });
__webpack_require__.d(__webpack_exports__, "MarkerTypeFill", function() { return /* reexport */ markerTypes_MarkerTypeFill; });
__webpack_require__.d(__webpack_exports__, "MarkerType", function() { return /* reexport */ markerTypes_MarkerType; });
__webpack_require__.d(__webpack_exports__, "IEnhancedMapping", function() { return /* reexport */ /* Cannot get final name for export "IEnhancedMapping" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "IMap", function() { return /* reexport */ /* Cannot get final name for export "IMap" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "IMarker", function() { return /* reexport */ /* Cannot get final name for export "IMarker" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "ILayer", function() { return /* reexport */ /* Cannot get final name for export "ILayer" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "ICircle", function() { return /* reexport */ /* Cannot get final name for export "ICircle" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "ILatLngBounds", function() { return /* reexport */ /* Cannot get final name for export "ILatLngBounds" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "ILatLng", function() { return /* reexport */ /* Cannot get final name for export "ILatLng" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "IGeoCodeResponse", function() { return /* reexport */ /* Cannot get final name for export "IGeoCodeResponse" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "MapSearch", function() { return /* reexport */ components_MapSearch; });
__webpack_require__.d(__webpack_exports__, "MultiMarker", function() { return /* reexport */ MultiMarker_MultiMarker; });
__webpack_require__.d(__webpack_exports__, "MarkerIcons", function() { return /* reexport */ MarkerIcons; });
__webpack_require__.d(__webpack_exports__, "IPolygon", function() { return /* reexport */ /* Cannot get final name for export "IPolygon" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "IPolyLine", function() { return /* reexport */ /* Cannot get final name for export "IPolyLine" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "IHeatMap", function() { return /* reexport */ /* Cannot get final name for export "IHeatMap" in "./src/scripts/Types.ts" (known exports: ExternalMapLayerParameter, known reexports: ) */ undefined; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

// EXTERNAL MODULE: external "axios"
var external_axios_ = __webpack_require__("cebe");
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_);

// CONCATENATED MODULE: ./src/scripts/Google/gps.service.ts



// `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&libraries=places`



var gps_service_GPSService = /*#__PURE__*/function () {
  function GPSService() {
    _classCallCheck(this, GPSService);

    this.axios = external_axios_default.a.create({
      baseURL: "https://maps.googleapis.com/maps/api/geocode/json"
    });
  }

  _createClass(GPSService, [{
    key: "geoCodeLookup",
    value: function geoCodeLookup(address, key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.get("", {
                  params: {
                    address: address,
                    key: key
                  }
                });

              case 2:
                return _context.abrupt("return", _context.sent.data);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return GPSService;
}();

/* harmony default export */ var gps_service = (gps_service_GPSService);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("28a5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__("551c");

// CONCATENATED MODULE: ./src/scripts/insertScript.service.ts


function getScript(source) {
  // TODO: guarantee once loaded
  return new Promise(function (resolve, reject) {
    // if (document.querySelector('script[src="' + source + '"]')) {
    if (document.querySelector('script[src*="' + source.split("/")[2] + '"]')) {
      // Already have the script on the page.
      resolve();
      return;
    }

    var script = document.createElement("script");
    var prior = document.getElementsByTagName("script")[0];
    script.async = true;
    script.defer = true;
    script.src = source;

    if (document.documentElement != null) {
      document.documentElement.appendChild(script);
    }

    script.onload = function () {
      resolve("Resolved!");
    };

    script.onerror = function () {
      reject();
    };
  });
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f543db7a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MapSearch.vue?vue&type=template&id=360de41f&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-search",class:{ 'show-map-search' : _vm.mapSearchOpen }},[_c('div',{staticClass:"alert alert-secondary location-search-control",staticStyle:{"min-height":"64px"}},[(!_vm.hideMapSearch)?_c('div',{staticClass:"input-group search-input",staticStyle:{"flex-wrap":"nowrap","max-height":"40px"}},[_c('div',{staticClass:"flex-grow-1"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchType === 'location'),expression:"searchType === 'location'"}],ref:"locationSearch",staticClass:"form-control shrink",staticStyle:{"height":"unset","min-height":"40px","min-width":"120px"},attrs:{"data-cy":"location-search","type":"text","id":'tbLocation' + _vm.viewCellId,"placeholder":"Enter a location","aria-label":"Enter a location or area","aria-describedby":"basic-addon2"}}),_c('multiselect',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchType === 'asset'),expression:"searchType === 'asset'"}],staticClass:"shrink flex-grow-1 location-multiselect asset-search",attrs:{"label":"title","placeholder":"Search for an asset or zone","open-direction":"bottom","options":_vm.searchedAssets,"searchable":true,"allow-empty":true,"loading":_vm.assetSearchLoading,"internal-search":false,"multiple":false,"hideSelected":false,"resetAfter":true,"selectLabel":"","deselectLabel":"","selectedLabel":"","allowEmpty":false},on:{"search-change":_vm.findAsset,"select":_vm.assetSelected},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('span',{staticStyle:{"text-overflow":"ellipsis","white-space":"nowrap"}},[_vm._v(_vm._s(option.groupTitle))])]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_c('div',{staticClass:"d-flex align-items-center"},[(option.item.mapLayerItemTypeID)?_c('img',{staticClass:"legend-icon",attrs:{"alt":option.groupTitle,"title":option.groupTitle,"src":_vm.mapIcons[option.item.mapLayerItemTypeID]}}):_c('img',{staticClass:"legend-icon",attrs:{"alt":"","src":'./images/enhancedmapping/home.png'}}),_c('span',{staticClass:"whitespace-normal"},[_vm._v(_vm._s(option.groupTitle))])])]}}],null,false,4097621053),model:{value:(_vm.selectedAsset),callback:function ($$v) {_vm.selectedAsset=$$v},expression:"selectedAsset"}},[_c('template',{slot:"noOptions"},[_c('span',{staticStyle:{"margin":"8px","display":"block"}},[_vm._v("Search for an asset or zone")])]),_c('template',{slot:"noResult"},[_c('span',{staticStyle:{"margin":"8px","display":"block"}},[_vm._v("No assets found")])])],2)],1),_c('div',{staticClass:"input-group-prepend ml-2"},[_c('button',{staticClass:"btn no-shadow",class:{ 'btn-primary': _vm.searchType === 'asset', 'btn-secondary': _vm.searchType !== 'asset' },attrs:{"data-cy":"search_asset_btn","type":"button"},on:{"click":function($event){_vm.searchType = 'asset'}}},[_vm._v("Assets")]),_c('button',{staticClass:"btn btn-sm no-shadow",class:{ 'btn-primary': _vm.searchType === 'location', 'btn-secondary': _vm.searchType !== 'location' },attrs:{"data-cy":"search_location_btn","type":"button"},on:{"click":function($event){_vm.searchType = 'location'}}},[_vm._v("Address")])])]):_vm._e()]),_c('div',{staticClass:"expand-grip"},[_c('div',{staticClass:"alert-secondary trapezoid",attrs:{"title":_vm.Search,"data-cy":"search-tab"},on:{"click":_vm.mapSearchToggle}}),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-map-marked-alt"}),_vm._v("\n        Search\n      ")])}]


// CONCATENATED MODULE: ./src/components/MapSearch.vue?vue&type=template&id=360de41f&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.to-string.js
var es6_regexp_to_string = __webpack_require__("6b54");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.construct.js
var es6_reflect_construct = __webpack_require__("2397");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var vue_multiselect_min = __webpack_require__("8e5f");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// EXTERNAL MODULE: external "vuex-class"
var external_vuex_class_ = __webpack_require__("c590");

// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__("5880");
var external_vuex_default = /*#__PURE__*/__webpack_require__.n(external_vuex_);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// CONCATENATED MODULE: ./src/scripts/mapUtility.ts



var getLatLngPolarity = function getLatLngPolarity(latLng) {
  var regex = /([0-9]?[0-9]|[0-9])\.{1}\d{1,16}([A-Z])/g;
  var result = regex.exec(latLng);

  if (typeof result !== "undefined" && result !== null && result.length === 3) {
    return result[2];
  }

  return "";
};

var convertStringToLatLng = function convertStringToLatLng(latLng) {
  var stringArray = latLng.split(" ");
  var latString = stringArray[0];
  var lat = parseFloat(latString);

  if (getLatLngPolarity(latString).toLowerCase() === "s") {
    // if it is west polarity, convert to east
    lat = lat * -1;
  }

  var lngString = stringArray[1];
  var lng = parseFloat(lngString);

  if (getLatLngPolarity(lngString).toLowerCase() === "w") {
    // if it is south polarity, convert to north
    lng = lng * -1;
  }

  return {
    lat: lat,
    lng: lng
  };
};

var addMeterToCoord = function addMeterToCoord(longMeters, latMeters, latLng) {
  // number of km per degree = ~111km (111.32 in google maps, but range varies between 110.567km at the equator and 111.699km at the poles)
  // 1km in degree = 1 / 111.32km = 0.0089
  // 1m in degree = 0.0089 / 1000 = 0.0000089
  var latCoef = latMeters * 0.0000089;
  var longCoef = longMeters * 0.0000089;
  var lat = latLng.lat + latCoef;
  var lng = latLng.lng + longCoef / Math.cos(latLng.lat * 0.018);
  return {
    lat: lat,
    lng: lng
  };
};

var stringToBounds = function stringToBounds(NE, SW) {
  var neArray = NE.split(" ");
  var neLat = neArray[0];
  var neLng = neArray[1];
  var swArray = SW.split(" ");
  var swLat = swArray[0];
  var swLng = swArray[1];
  return {
    north: parseFloat(neLat),
    east: parseFloat(neLng),
    south: parseFloat(swLat),
    west: parseFloat(swLng)
  };
};

var union = function union(bounds1, bounds2) {
  return {
    north: !bounds1.north || isNaN(bounds1.north) ? bounds2.north : !bounds2.north || isNaN(bounds2.north) ? bounds1.north : Math.max(bounds1.north, bounds2.north),
    east: !bounds1.east || isNaN(bounds1.east) ? bounds2.east : !bounds2.east || isNaN(bounds2.east) ? bounds1.east : Math.max(bounds1.east, bounds2.east),
    south: !bounds1.south || isNaN(bounds1.south) ? bounds2.south : !bounds2.south || isNaN(bounds2.south) ? bounds1.south : Math.min(bounds1.south, bounds2.south),
    west: !bounds1.west || isNaN(bounds1.west) ? bounds2.west : !bounds2.west || isNaN(bounds2.west) ? bounds1.west : Math.min(bounds1.west, bounds2.west)
  };
};

var extend = function extend(bounds, position) {
  return {
    north: !bounds.north || isNaN(bounds.north) ? position.lat : !position.lat || isNaN(position.lat) ? bounds.north : Math.max(bounds.north, position.lat),
    east: !bounds.east || isNaN(bounds.east) ? position.lng : !position.lng || isNaN(position.lng) ? bounds.east : Math.max(bounds.east, position.lng),
    south: !bounds.south || isNaN(bounds.south) ? position.lat : !position.lat || isNaN(position.lat) ? bounds.south : Math.min(bounds.south, position.lat),
    west: !bounds.west || isNaN(bounds.west) ? position.lng : !position.lng || isNaN(position.lng) ? bounds.west : Math.min(bounds.west, position.lng)
  };
};

var combine = function combine(positions) {
  if (!positions || positions.length === 0) return null;
  var bounds = {};
  positions.forEach(function (point) {
    bounds = extend(bounds, point);
  });
  return bounds;
};


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MapSearch.vue?vue&type=script&lang=ts&










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







external_vue_property_decorator_["Vue"].use(external_vuex_default.a);
var MapLayers = Object(external_vuex_class_["namespace"])("mapLayers");

var MapSearchvue_type_script_lang_ts_MapSearch = /*#__PURE__*/function (_Vue) {
  _inherits(MapSearch, _Vue);

  var _super = _createSuper(MapSearch);

  function MapSearch() {
    var _this;

    _classCallCheck(this, MapSearch);

    _this = _super.apply(this, arguments);
    _this.autocomplete = null;
    _this.searchType = "asset";
    _this.selectedAsset = null;
    _this.createdAutocomplete = false;
    _this.assetSearchLoading = false;
    _this.searchedAssets = [];
    _this.mapSearchOpen = false;
    _this.hideMapSearch = true;
    return _this;
  } // On typing into multiselect, this method uses typed characters to get
  // all assets with those characters and popoulate them as options.


  _createClass(MapSearch, [{
    key: "findAsset",
    value: function findAsset(query) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(query == "")) {
                  _context.next = 3;
                  break;
                }

                this.searchedAssets = [];
                return _context.abrupt("return");

              case 3:
                this.assetSearchLoading = true;
                params = {
                  searchTerm: query,
                  count: 20,
                  ne: null,
                  sw: null
                };

                if (this.bounds) {
                  params.ne = this.bounds.north + " " + this.bounds.east;
                  params.sw = this.bounds.south + " " + this.bounds.west;
                }

                _context.next = 8;
                return this.searchAssets(params);

              case 8:
                this.searchedAssets = _context.sent;
                this.assetSearchLoading = false;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    } // Once an asset is selected from the options, the map moves to that location.

  }, {
    key: "assetSelected",
    value: function assetSelected(asset) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.goToLocation({
                  location: asset.item.latLong,
                  bounds: asset.region,
                  minElevation: asset.item.minElevation,
                  maxElevation: asset.item.maxElevation
                });
                this.selectedAsset = null;

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    } // Method is run when asset is selected.

  }, {
    key: "goToLocation",
    value: function goToLocation(locationItem) {
      // Depending on info provided with asset, use lat and lng or map bounds
      // to go to location.
      if (locationItem.location) {
        this.map.center = convertStringToLatLng(locationItem.location);

        if (this.map.zoom < 19) {
          this.map.zoom = 19;
        }
      } else if (locationItem.bounds) {
        this.map.mapBounds = locationItem.bounds;
      } // Ensure map elevation is within camera max and min elevation.
      // If not, adjust elevation so that it is.


      if (locationItem.minElevation && locationItem.minElevation > this.getElevation) {
        this.gotoElevationByValue(locationItem.minElevation);
      }

      if (locationItem.maxElevation && locationItem.maxElevation < this.getElevation) {
        this.gotoElevationByValue(locationItem.maxElevation);
      }
    }
  }, {
    key: "gotoElevationByValue",
    value: function gotoElevationByValue(elevation) {
      var matchingFloors = this.elevationList.filter(function (elevationItem) {
        return elevationItem.elevationValue == elevation;
      }); // If we do have matching floors, tell the map that the mapSearch component
      // is embedded in, to go to the elevation.

      if (matchingFloors.length > 0) {
        this.$emit("goToElevation", matchingFloors[0]);
      }
    } // Method used when searching for a location.

  }, {
    key: "setAutocomplete",
    value: function setAutocomplete() {
      var _this2 = this;

      setTimeout(function () {
        // Use google map API to provide an autocomplete service when user types.
        _this2.autocomplete = new google.maps.places.Autocomplete(document.getElementById( // The viewCellId is specific to "Views"as there exists multiple view cells,
        // when this component is not used in views,
        // this defaults to 0 and tbLocation0 is used as a regular ID with no special meaning.
        "tbLocation" + _this2.viewCellId));

        _this2.autocomplete.setFields(["address_components", "geometry", "name"]); // This listener is added to the search box to listen for when a user selects a place.


        _this2.autocomplete.addListener("place_changed", function () {
          var place = _this2.autocomplete.getPlace(); // Change the map location to the location selected via service provided by google api autocomplete service.


          if (place.geometry) {
            if (place.geometry.viewport) {
              _this2.setMapLocation({
                viewport: place.geometry.viewport,
                location: place.geometry.location
              });
            } else if (place.geometry.location) {
              _this2.setMapLocation({
                location: place.geometry.location
              });
            }
          }
        });
      }, 500);
    } // Method is run when a user selects an address for a location.

  }, {
    key: "setMapLocation",
    value: function setMapLocation(location) {
      // Depending on the data received, use either the map bounds or lat/lng to move map to location.
      if (location) {
        if (location.viewport) {
          this.map.mapBounds = location.viewport;
        } else if (location.location) {
          this.map.center = location.location;
          this.map.zoom = 17;
        }
      }
    } // searchType can alter between asset and location. This is watched as the setAutoComplete is run
    // when the searchType is set to location. This will start the autocomplete service via the google maps API.

  }, {
    key: "searchTypeUpdated",
    value: function searchTypeUpdated(value) {
      if (value === "location" && !this.createdAutocomplete) {
        this.createdAutocomplete = true;
        this.setAutocomplete();
      }
    } // Executed when search button is clicked. to hide/show the search box.

  }, {
    key: "mapSearchToggle",
    value: function mapSearchToggle() {
      var _this3 = this;

      // Toggle the flag so that the correct class is applied to show/hide the search box.
      this.mapSearchOpen = !this.mapSearchOpen; // If searchbox closed, then opened, re-run setAutoComplete otherwise
      // the autoComplete service does not run anymore via google maps API.

      if (this.searchType == "location" && this.mapSearchOpen) {
        this.setAutocomplete();
      } // hideMapSearch is a separate flag that removes the search box when hidden
      // to prevent the search box using excess width.


      if (this.mapSearchOpen) {
        this.hideMapSearch = false;
      } else {
        //Wait for the transition to finish then hide MapSearch
        setTimeout(function () {
          return _this3.hideMapSearch = true;
        }, 500);
      }
    }
  }]);

  return MapSearch;
}(external_vue_property_decorator_["Vue"]);

__decorate([Object(external_vue_property_decorator_["Prop"])()], MapSearchvue_type_script_lang_ts_MapSearch.prototype, "bounds", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  type: Number,
  default: 0
})], MapSearchvue_type_script_lang_ts_MapSearch.prototype, "viewCellId", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: null
})], MapSearchvue_type_script_lang_ts_MapSearch.prototype, "map", void 0);

__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: null
})], MapSearchvue_type_script_lang_ts_MapSearch.prototype, "elevationList", void 0);

__decorate([MapLayers.Getter("getMapItemIcons")], MapSearchvue_type_script_lang_ts_MapSearch.prototype, "mapIcons", void 0);

__decorate([MapLayers.Getter("getElevation")], MapSearchvue_type_script_lang_ts_MapSearch.prototype, "getElevation", void 0);

__decorate([MapLayers.Action], MapSearchvue_type_script_lang_ts_MapSearch.prototype, "searchAssets", void 0);

__decorate([Object(external_vue_property_decorator_["Watch"])("searchType")], MapSearchvue_type_script_lang_ts_MapSearch.prototype, "searchTypeUpdated", null);

MapSearchvue_type_script_lang_ts_MapSearch = __decorate([Object(external_vue_property_decorator_["Component"])({
  components: {
    multiselect: vue_multiselect_min_default.a
  }
})], MapSearchvue_type_script_lang_ts_MapSearch);
/* harmony default export */ var MapSearchvue_type_script_lang_ts_ = (MapSearchvue_type_script_lang_ts_MapSearch);
// CONCATENATED MODULE: ./src/components/MapSearch.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_MapSearchvue_type_script_lang_ts_ = (MapSearchvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/components/MapSearch.vue?vue&type=style&index=0&lang=scss&
var MapSearchvue_type_style_index_0_lang_scss_ = __webpack_require__("5389");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/MapSearch.vue






/* normalize component */

var component = normalizeComponent(
  components_MapSearchvue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var components_MapSearch = (component.exports);
// CONCATENATED MODULE: ./src/scripts/MultiMarker.ts




var MultiMarker_MultiMarker = /*#__PURE__*/function () {
  /**
   * Create a new multi-marker
   * @param enhancedMapping Mapping system
   * @param map Map to draw markers to
   * @param multiMarkerType Type of markers to create
   * @param points List of GPS points
   */
  function MultiMarker(enhancedMapping, map, title, multiMarkerType, points, click) {
    _classCallCheck(this, MultiMarker);

    this.markers = [];
    this.enhancedMapping = enhancedMapping;
    this.map = map;
    this.title = title;
    this.multiMarkerType = multiMarkerType;
    this.points = points;
    this.click = click;

    for (var i = 0; i < points.length; i++) {
      this.addPoint(points[i]);
    }
  }

  _createClass(MultiMarker, [{
    key: "setStateAtIndex",

    /**
     * Set the state of a marker at an specific index in list
     * @param index Marker index
     * @param state New state
     */
    value: function setStateAtIndex(index, state) {
      if (this.markers[index]) {
        this.markers[index].state = state;
      }
    }
    /**
     * Remove all markers
     */

  }, {
    key: "remove",
    value: function remove() {
      this.markers.forEach(function (marker) {
        marker.remove();
      });
    }
  }, {
    key: "addPoint",
    value: function addPoint(point) {
      var _this = this;

      var newPoint = this.enhancedMapping.createMarker(this.map, null, null, this.multiMarkerType, null, this.title, point, null, null, null, true);

      newPoint.click = function () {
        if (_this.click) {
          _this.click(newPoint, _this.markers.indexOf(newPoint));
        }
      };

      if (this.markers.length > 0) {
        newPoint.state = "last";

        if (this.markers[this.markers.length - 1].state === "last") {
          this.markers[this.markers.length - 1].state = null;
        }

        this.markers[this.markers.length - 1].lineTo(point);
      } else {
        newPoint.state = "first";
      }

      this.markers.push(newPoint);
      return newPoint;
    }
  }, {
    key: "visible",
    get: function get() {
      return this._visible;
    },
    set: function set(value) {
      if (this._visible !== value) {
        this._visible = value;
        this.markers.forEach(function (marker) {
          return marker.visible = value;
        });
      }
    }
  }, {
    key: "lineMarkers",
    get: function get() {
      return this.markers;
    }
  }, {
    key: "showlines",
    get: function get() {
      return this._showLines;
    },
    set: function set(value) {
      if (this._showLines !== value) {
        this._showLines = value;

        if (value) {
          for (var i = 0; i < this.markers.length - 1; i++) {
            if (this.markers[i]) {
              this.markers[i].lineTo(this.points[i + 1]);
            }
          }
        } else {
          this.markers.forEach(function (marker) {
            return marker.lineTo(null);
          });
        }
      }
    }
  }]);

  return MultiMarker;
}();


// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.entries.js
var es7_object_entries = __webpack_require__("ffc1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__("20d6");

// CONCATENATED MODULE: ./src/scripts/Google/cornerBounds.ts


// tslint:disable-next-line:class-name
var cornerBounds_cornerBounds = function cornerBounds(raw, ne, sw) {
  _classCallCheck(this, cornerBounds);

  this.ne = ne;
  this.sw = sw;
  this.raw = raw;
};


// CONCATENATED MODULE: ./src/scripts/Google/map.ts



/// <reference types="@types/googlemaps" />
// import { } from 'googlemaps';

window.google = window.google || {}; // tslint:disable-next-line:class-name

var map_eventMap = function eventMap() {
  _classCallCheck(this, eventMap);
};

var map_GoogleMap = /*#__PURE__*/function () {
  function GoogleMap(containerElement, center, zoomLevel, streetview, mapViewType, mapStyles) {
    var _this = this;

    _classCallCheck(this, GoogleMap);

    this.minLevelForFullIcons = 17;
    this.minLevelForItems = 14;
    this.currentViewState = null;
    this.viewportChangedTimeout = null;
    this.staticMapIcon = false;
    this.events = new map_eventMap();
    this._mobileMode = false;

    if (typeof window.google === "undefined") {
      throw new ReferenceError("Google Maps is not defined");
    }

    this.container = containerElement;
    var mapTypeId = google.maps.MapTypeId.HYBRID;

    if (mapViewType) {
      switch (mapViewType.toLowerCase()) {
        case "terrain":
          mapTypeId = google.maps.MapTypeId.TERRAIN;
          break;

        case "roadmap":
          mapTypeId = google.maps.MapTypeId.ROADMAP;
          break;

        case "satellite":
          mapTypeId = google.maps.MapTypeId.SATELLITE;
          break;

        case "hybrid":
          mapTypeId = google.maps.MapTypeId.HYBRID;
          break;
      }
    }

    this.events["onViewportChanged"] = new Array();
    this.events["onViewportChangedDelayed"] = new Array();
    this.events["onDisplayTypeChanged"] = new Array();
    this.events["onClick"] = new Array();
    this.events["onMapTypeChanged"] = new Array();
    this.events["onDragStart"] = new Array();
    this.map = new google.maps.Map(this.container, {
      center: center,
      zoom: zoomLevel,
      mapTypeId: mapTypeId,
      mapTypeControl: true,
      zoomControl: true,
      scaleControl: false,
      streetViewControl: streetview,
      fullscreenControl: false,
      rotateControl: false,
      styles: mapStyles,
      backgroundColor: "none"
    });
    this.map.setTilt(0);
    this.map.addListener("dragstart", function (event) {
      _this.raise("onDragStart", event);
    });
    this.map.addListener("zoom_changed", function () {
      return _this.zoomLevelSet(_this.map.getZoom(), true);
    });
    this.map.addListener("bounds_changed", function () {
      return _this.handleBoundsChanged();
    });
    this.map.addListener("click", function (event) {
      var eventPosition = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };

      _this.raise("onClick", eventPosition);
    });
    this.map.addListener("maptypeid_changed", function () {
      _this.raise("onMapTypeChanged", _this.map.getMapTypeId());
    });
    this.zoomLevelSet(zoomLevel, false);
  }

  _createClass(GoogleMap, [{
    key: "handleBoundsChanged",
    value: function handleBoundsChanged() {
      var _this2 = this;

      this.raise("onViewportChanged", {});

      if (this.viewportChangedTimeout != null) {
        clearTimeout(this.viewportChangedTimeout);
      }

      this.viewportChangedTimeout = setTimeout(function () {
        _this2.raise("onViewportChangedDelayed", _this2.map.getBounds());
      }, 600);
    }
  }, {
    key: "zoomLevelSet",
    value: function zoomLevelSet(currentZoomLevel, raise) {
      var hasChanged = false;

      if (currentZoomLevel < this.minLevelForItems && !this.staticMapIcon) {
        if (this.currentViewState === "wide") {
          return;
        }

        this.currentViewState = "wide";
        hasChanged = true;
      } else if (currentZoomLevel <= this.minLevelForFullIcons && currentZoomLevel >= this.minLevelForItems && !this.staticMapIcon) {
        if (this.currentViewState === "medium") {
          return;
        }

        this.currentViewState = "medium";
        hasChanged = true;
      } else if (currentZoomLevel > this.minLevelForItems) {
        if (this.currentViewState === "narrow") {
          return;
        }

        this.currentViewState = "narrow";
        hasChanged = true;
      }

      if (hasChanged && raise) {
        this.raise("onDisplayTypeChanged", {
          viewState: this.currentViewState
        });
      }
    }
  }, {
    key: "setMapTypeControlVisible",
    value: function setMapTypeControlVisible(value) {
      this.map.setOptions({
        mapTypeControl: value
      });
    }
  }, {
    key: "raise",
    value: function raise(event, arg) {
      this.events[event].forEach(function (handler) {
        handler(arg);
      });
    }
  }, {
    key: "registerEvent",
    value: function registerEvent(event, callback) {
      this.events[event].push(callback);
    }
  }, {
    key: "clearEvents",
    value: function clearEvents() {
      this.events["onViewportChanged"] = new Array();
      this.events["onViewportChangedDelayed"] = new Array();
      this.events["onDisplayTypeChanged"] = new Array();
      this.events["onClick"] = new Array();
      this.events["onMapTypeChanged"] = new Array();
      this.events["onDragStart"] = new Array();
    }
  }, {
    key: "getLatLngPolarity",
    value: function getLatLngPolarity(latLng) {
      var regex = /([1-8]?[1-9]|[1-9])\.{1}\d{1,16}([A-Z])/g;
      var result = regex.exec(latLng);

      if (typeof result !== "undefined" && result !== null && result.length === 3) {
        return result[2];
      }

      return "";
    }
  }, {
    key: "setCursor",
    value: function setCursor(cursor) {
      this.map.setOptions({
        draggableCursor: cursor
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.events["onViewportChanged"] = new Array();
      this.events["onViewportChangedDelayed"] = new Array();
      this.events["onDisplayTypeChanged"] = new Array();
      this.events["onClick"] = new Array();
      this.events["onMapTypeChanged"] = new Array();
      this.events["onDragStart"] = new Array();
    }
  }, {
    key: "bounds",
    get: function get() {
      var bounds = this.map.getBounds();
      return new cornerBounds_cornerBounds(bounds, bounds.getNorthEast(), bounds.getSouthWest());
    }
  }, {
    key: "center",
    get: function get() {
      var latLng = this.map.getCenter();
      return {
        lat: latLng.lat(),
        lng: latLng.lng()
      };
    },
    set: function set(value) {
      this.map.setCenter(value);
    }
  }, {
    key: "mobileMode",
    set: function set(value) {
      if (this._mobileMode !== value) {
        this._mobileMode = value;
        this.map.setOptions({
          mapTypeControl: !value,
          zoomControl: !value,
          gestureHandling: value ? "greedy" : "auto"
        });
      }
    },
    get: function get() {
      return this._mobileMode;
    }
  }, {
    key: "mapViewType",
    get: function get() {
      var mapTypeId = this.map.getMapTypeId();

      switch (mapTypeId) {
        case google.maps.MapTypeId.TERRAIN:
          return "terrain";

        case google.maps.MapTypeId.ROADMAP:
          return "roadmap";

        case google.maps.MapTypeId.SATELLITE:
          return "satellite";

        default:
          return "hybrid";
      }
    },
    set: function set(value) {
      switch (value.toLowerCase()) {
        case "terrain":
          this.map.setMapTypeId(google.maps.MapTypeId.TERRAIN);
          break;

        case "roadmap":
          this.map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
          break;

        case "satellite":
          this.map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
          break;

        default:
          this.map.setMapTypeId(google.maps.MapTypeId.HYBRID);
          break;
      }
    }
  }, {
    key: "mapStyles",
    set: function set(mapStyles) {
      this.map.setOptions({
        styles: mapStyles
      });
    }
  }, {
    key: "mapBounds",
    get: function get() {
      var bounds = this.map.getBounds();
      var ne = bounds.getNorthEast();
      var sw = bounds.getSouthWest();
      return {
        north: ne.lat(),
        east: ne.lng(),
        south: sw.lat(),
        west: sw.lng()
      };
    },
    set: function set(value) {
      this.map.fitBounds(value, 0);
    }
  }, {
    key: "zoom",
    get: function get() {
      return this.map.getZoom();
    },
    set: function set(value) {
      this.map.setZoom(value);
    }
  }]);

  return GoogleMap;
}();


// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.fill.js
var es6_array_fill = __webpack_require__("6c7b");

// CONCATENATED MODULE: ./src/scripts/Google/mapLabel.ts




/**
 * @license
 *
 * Copyright 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var mapLabel_MapLabel = /*#__PURE__*/function () {
  function MapLabel(options) {
    var _this = this;

    _classCallCheck(this, MapLabel);

    this.overlay = null;
    this.canvas = null;
    this.overlay = new google.maps.OverlayView();
    this.overlay.set("fontFamily", "sans-serif");
    this.overlay.set("fontSize", 8);
    this.overlay.set("fontColor", "#ffffff");
    this.overlay.set("strokeWeight", 0);
    this.overlay.set("strokeColor", "#ffffff");
    this.overlay.set("align", "center");
    this.overlay.set("zIndex", 1e3);
    this.overlay.setValues(options);

    this.overlay.onAdd = function () {
      return _this.onAdd();
    };

    this.overlay.draw = function () {
      return _this.draw();
    };

    this.overlay.onRemove = function () {
      return _this.onRemove();
    };
  }

  _createClass(MapLabel, [{
    key: "setMap",
    value: function setMap(map) {
      this.overlay.setMap(map);
    }
  }, {
    key: "changed",
    value: function changed(prop) {
      switch (prop) {
        case "fontFamily":
        case "fontSize":
        case "fontColor":
        case "strokeWeight":
        case "strokeColor":
        case "align":
        case "text":
          return this.drawCanvas_();

        case "maxZoom":
        case "minZoom":
        case "position":
          return this.draw();
      }
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      var canvas = this.canvas = document.createElement("canvas");
      var style = canvas.style;
      style.position = "absolute";
      var ctx = canvas.getContext("2d");
      ctx.lineJoin = "round";
      ctx.textBaseline = "top";
      this.drawCanvas_();
      var panes = this.overlay.getPanes();

      if (panes) {
        panes.mapPane.appendChild(canvas);
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      var projection = this.overlay.getProjection();

      if (!projection) {
        // The map projection is not ready yet so do nothing
        return;
      }

      if (!this.canvas) {
        // onAdd has not been called yet.
        return;
      }

      var latLng = this.overlay.get("position");

      if (!latLng) {
        return;
      }

      var pos = projection.fromLatLngToDivPixel(latLng);
      var style = this.canvas.style;
      style["top"] = pos.y + "px";
      style["left"] = pos.x + "px";
      style["visibility"] = this.getVisible_();
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      var canvas = this.canvas;

      if (canvas && canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    }
  }, {
    key: "drawCanvas_",
    value: function drawCanvas_() {
      var canvas = this.canvas;

      if (!canvas) {
        return;
      }

      var style = canvas.style;
      style.zIndex = this.overlay.get("zIndex");
      var ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = this.overlay.get("strokeColor");
      ctx.fillStyle = this.overlay.get("fontColor");
      ctx.font = this.overlay.get("fontSize") + "px " + this.overlay.get("fontFamily");
      var strokeWeight = Number(this.overlay.get("strokeWeight"));
      var text = this.overlay.get("text");

      if (text) {
        if (strokeWeight) {
          ctx.lineWidth = strokeWeight;
          ctx.strokeText(text, strokeWeight, strokeWeight);
        }

        ctx.fillText(text, strokeWeight, strokeWeight);
        var textMeasure = ctx.measureText(text);
        var textWidth = textMeasure.width + strokeWeight;
        style.marginLeft = this.getMarginLeft_(textWidth) + "px"; // Bring actual text top in line with desired latitude.
        // Cheaper than calculating height of text.

        style.marginTop = "-1.5em";
      }
    }
  }, {
    key: "getMarginLeft_",
    value: function getMarginLeft_(textWidth) {
      switch (this.overlay.get("align")) {
        case "left":
          return 0;

        case "right":
          return -textWidth;
      }

      return textWidth / -2;
    }
  }, {
    key: "getVisible_",
    value: function getVisible_() {
      var minZoom = this.overlay.get("minZoom");
      var maxZoom = this.overlay.get("maxZoom");

      if (minZoom === undefined && maxZoom === undefined) {
        return "";
      }

      var map = this.overlay.getMap();

      if (!map) {
        return "";
      }

      var mapZoom = map.getZoom();

      if (mapZoom < minZoom || mapZoom > maxZoom) {
        return "hidden";
      }

      return "";
    }
  }]);

  return MapLabel;
}();


// CONCATENATED MODULE: ./src/scripts/markerTypes.ts



var markerTypes_MarkerTypeLine = function MarkerTypeLine() {
  _classCallCheck(this, MarkerTypeLine);

  this.color = "";
  this.opacity = 1;
  this.weight = 1;
};

var markerTypes_MarkerTypeFill = function MarkerTypeFill() {
  _classCallCheck(this, MarkerTypeFill);

  this.color = "";
  this.opacity = 1;
};

var markerTypes_MarkerState = function MarkerState() {
  _classCallCheck(this, MarkerState);

  this.imageUrl = "";
  this.line = null;
  this.fill = null;
  this.hidden = false;
  this.opacity = 1;
};

var markerTypes_MarkerStateMap = function MarkerStateMap() {
  _classCallCheck(this, MarkerStateMap);
};

var markerTypes_MarkerType = /*#__PURE__*/function () {
  function MarkerType(defaultState, states) {
    _classCallCheck(this, MarkerType);

    this.defaultState = defaultState;
    this.states = states;
  }

  _createClass(MarkerType, [{
    key: "stateGet",
    value: function stateGet(state) {
      if (!this.states || !this.states[state]) {
        return this.defaultState;
      }

      return this.states[state];
    }
  }]);

  return MarkerType;
}();


// CONCATENATED MODULE: ./src/scripts/markerTypesDef.ts






var markerTypesDef_MarkerTypeMap = function MarkerTypeMap() {
  _classCallCheck(this, MarkerTypeMap);
};

var markerTypesDef_MarkerIconMap = function MarkerIconMap() {
  _classCallCheck(this, MarkerIconMap);
};

var baseLocationImagesFolder = "./images/enhancedmapping/";
var MarkerIcons = new markerTypesDef_MarkerIconMap(); // exported and used in the main UI project to get Marker Icons
// set default icons

MarkerIcons[1] = "".concat(baseLocationImagesFolder, "camera_active.svg");
MarkerIcons[2] = "".concat(baseLocationImagesFolder, "intercom.svg");
MarkerIcons[3] = "".concat(baseLocationImagesFolder, "door_active.svg");
MarkerIcons[4] = "".concat(baseLocationImagesFolder, "alarm_active.svg");
MarkerIcons[5] = "".concat(baseLocationImagesFolder, "output.svg");
MarkerIcons[6] = "".concat(baseLocationImagesFolder, "link.svg");
MarkerIcons[100] = "".concat(baseLocationImagesFolder, "guard.svg");
MarkerIcons[101] = "".concat(baseLocationImagesFolder, "tour_waypoint_active.svg");
var MarkerTypes = new markerTypesDef_MarkerTypeMap(); // Setup default marker icons and states

MarkerTypes["1"] = new markerTypes_MarkerType({
  imageUrl: baseLocationImagesFolder + "camera.svg",
  line: {
    color: "#3D82C4",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#3D82C4",
    opacity: 0.4
  }
}, {
  active: {
    imageUrl: MarkerIcons[1],
    line: {
      color: "#3D82C4",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#3D82C4",
      opacity: 0.4
    }
  }
});
MarkerTypes["2"] = new markerTypes_MarkerType({
  imageUrl: MarkerIcons[2],
  line: {
    color: "#F37046",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#F37046",
    opacity: 0.4
  }
}, null);
MarkerTypes["3"] = new markerTypes_MarkerType({
  imageUrl: baseLocationImagesFolder + "door.svg",
  line: {
    color: "#795649",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#795649",
    opacity: 0.4
  }
}, {
  active: {
    imageUrl: MarkerIcons[3],
    line: {
      color: "#795649",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#795649",
      opacity: 0.4
    }
  }
});
MarkerTypes["4"] = new markerTypes_MarkerType({
  imageUrl: baseLocationImagesFolder + "alarm_inactive.svg",
  line: {
    color: "#cfd8dc",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#cfd8dc",
    opacity: 0.4
  },
  hidden: true
}, {
  inactive: {
    imageUrl: baseLocationImagesFolder + "alarm_inactive.svg",
    line: {
      color: "#cfd8dc",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#cfd8dc",
      opacity: 0.4
    }
  },
  active: {
    imageUrl: MarkerIcons[4],
    line: {
      color: "#b72025",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#b72025",
      opacity: 0.4
    }
  },
  mutedactive: {
    imageUrl: MarkerIcons[4],
    line: {
      color: "#b72025",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#b72025",
      opacity: 0.4
    },
    opacity: 0.1
  },
  processing: {
    imageUrl: baseLocationImagesFolder + "alarm_acknowledged.svg",
    line: {
      color: "#fcb64e",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#fcb64e",
      opacity: 0.4
    }
  },
  mutedprocessing: {
    imageUrl: baseLocationImagesFolder + "alarm_acknowledged.svg",
    line: {
      color: "#fcb64e",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#fcb64e",
      opacity: 0.4
    },
    opacity: 0.1
  },
  highlightactive: {
    imageUrl: baseLocationImagesFolder + "alarm_activehighlight.svg",
    line: {
      color: "#fcb64e",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#fcb64e",
      opacity: 0.4
    }
  },
  highlightprocessing: {
    imageUrl: baseLocationImagesFolder + "alarm_acknowledgedhighlight.svg",
    line: {
      color: "#fcb64e",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#fcb64e",
      opacity: 0.4
    }
  },
  investigating: {
    imageUrl: baseLocationImagesFolder + "alarm_investigating.svg",
    line: {
      color: "#2196F3",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#2196F3",
      opacity: 0.4
    }
  }
});
MarkerTypes["5"] = new markerTypes_MarkerType({
  imageUrl: MarkerIcons[5],
  line: {
    color: "#66bb6a",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#66bb6a",
    opacity: 0.4
  }
}, null);
MarkerTypes["6"] = new markerTypes_MarkerType({
  imageUrl: MarkerIcons[6],
  line: {
    color: "#5f449b",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#5f449b",
    opacity: 0.4
  }
}, null);
MarkerTypes["tour-marker"] = new markerTypes_MarkerType({
  imageUrl: baseLocationImagesFolder + "tour_waypoint.svg",
  line: {
    color: "#aaaaaa",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#aaaaaa",
    opacity: 0.4
  }
}, {
  active: {
    imageUrl: MarkerIcons[101],
    line: {
      color: "#aaaaaa",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#aaaaaa",
      opacity: 0.4
    }
  }
}); // Notes Marker

MarkerTypes["102"] = new markerTypes_MarkerType({
  imageUrl: baseLocationImagesFolder + "note.svg",
  line: {
    color: "#aaaaaa",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#aaaaaa",
    opacity: 0.4
  }
}, null);
MarkerTypes["101"] = MarkerTypes["tour-marker"];
MarkerTypes["guard"] = new markerTypes_MarkerType({
  imageUrl: MarkerIcons[100],
  line: {
    color: "#2196F3",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#5f449b",
    opacity: 0.4
  }
}, {
  available: {
    imageUrl: MarkerIcons[100],
    line: {
      color: "#aaaaaa",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#aaaaaa",
      opacity: 0.4
    }
  },
  investigating: {
    imageUrl: baseLocationImagesFolder + "guard_investigating.svg",
    line: {
      color: "#2196F3",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#2196F3",
      opacity: 0.4
    }
  },
  unavailable: {
    imageUrl: baseLocationImagesFolder + "guard_unavailable.svg",
    line: {
      color: "#e51c23",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#e51c23",
      opacity: 0.4
    }
  },
  enroute: {
    imageUrl: baseLocationImagesFolder + "guard_enroute.svg",
    line: {
      color: "#fd7e14",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#fd7e14",
      opacity: 0.4
    }
  },
  ontour: {
    imageUrl: baseLocationImagesFolder + "guard_ontour.svg",
    line: {
      color: "#2196F3",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#2196F3",
      opacity: 0.4
    }
  }
});
MarkerTypes["100"] = MarkerTypes["guard"];
MarkerTypes["patrol-zone"] = new markerTypes_MarkerType({
  imageUrl: null,
  line: {
    color: "#aaaaaa",
    opacity: 0.75,
    weight: 1
  },
  fill: {
    color: "#aaaaaa",
    opacity: 0.1
  }
}, {
  active: {
    imageUrl: null,
    line: {
      color: "#aaaaaa",
      opacity: 0.75,
      weight: 1
    },
    fill: {
      color: "#aaaaaa",
      opacity: 0.1
    }
  }
});

function getMarkerTypes() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var axios, result, customMapitemTypes;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // if axios is defined, we must be logged in to the main UI, there for go to the DB and get the marker types
            axios = window["axios.instance"];

            if (!(axios && axios.axiosInstance)) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return axios.axiosInstance.get("/MapLayers/ItemTypes");

          case 4:
            result = _context.sent;

            if (result && result.data) {
              customMapitemTypes = result.data;
              customMapitemTypes.forEach(function (item) {
                // we only want to process anything that is not already in MarkerTypes
                if (!MarkerTypes[item.mapLayerItemTypeID]) {
                  // if an icon is set, set the URL for the API to get the image
                  if (item.icon) {
                    MarkerIcons[item.mapLayerItemTypeID] = "".concat(window.location.protocol + "//" + window.location.hostname, "/api/MapLayers/MapLayerItems/Image/").concat(item.mapLayerItemTypeID);
                  } // create the new marker type


                  MarkerTypes[item.mapLayerItemTypeID] = new markerTypes_MarkerType({
                    imageUrl: MarkerIcons[item.mapLayerItemTypeID],
                    line: {
                      color: item.lineColor,
                      opacity: item.lineOpacity,
                      weight: 1
                    },
                    fill: {
                      color: item.fillColor,
                      opacity: item.fillOpacity
                    }
                  }, null);
                }
              });
            }

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}


// CONCATENATED MODULE: ./src/scripts/Google/marker.ts










var marker_Marker = /*#__PURE__*/function () {
  function Marker(enhancedMapping, mapLayerItemID, eventRecordID, mapLayerItemTypeID, objectID, title, position, regionPath, minElevation, maxElevation, visible) {
    var _this = this;

    _classCallCheck(this, Marker);

    this.poly = null;
    this.line = null;
    this.label = null;
    this._state = "";
    this.click = null;
    this.rightclick = null;
    this.dragend = null;
    this._markerTypeVisible = true;
    this.mapLayerItemID = mapLayerItemID;
    this.eventRecordID = eventRecordID;
    this.mapLayerItemTypeID = mapLayerItemTypeID.toString();
    this.objectID = objectID;
    this.title = title;
    this.map = enhancedMapping.map;
    this.position = position;
    this._visible = visible;
    this._regionPathVisible = true;

    if (_typeof(mapLayerItemTypeID) === 'object') {
      this.markerType = mapLayerItemTypeID;
    } else {
      this.markerType = MarkerTypes[mapLayerItemTypeID];
    }

    if (this.markerType) {
      this._markerState = this.markerType.defaultState;
      this.marker = new google.maps.Marker({
        position: position,
        title: title,
        map: visible ? this.map : undefined,
        icon: this.image,
        opacity: this._markerState.opacity === undefined || this._markerState.opacity === null ? 1 : this._markerState.opacity
      });
      this.marker.addListener("click", function (event) {
        if (_this.click != null) {
          var eventPosition = null;

          if (event && event.latLng) {
            eventPosition = {
              lat: event.latLng.lat(),
              lng: event.latLng.lng()
            };
          }

          _this.click(eventPosition);
        }
      });
      this.marker.addListener("rightclick", function (event) {
        if (_this.rightclick != null) {
          _this.rightclick(event);
        }
      });
      this.marker.addListener("dragend", function (event) {
        if (_this.dragend != null) {
          var eventPosition = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
          };

          _this.dragend(eventPosition);
        }
      });
    }

    if (this.markerType && regionPath != null && regionPath !== "") {
      var polyPath = this.polygonPathFromString(regionPath);
      this.poly = new google.maps.Polygon({
        map: visible ? this.map : undefined,
        paths: polyPath,
        strokeColor: this.markerState.line.color,
        strokeOpacity: this.markerState.line.opacity,
        strokeWeight: this.markerState.line.weight,
        fillColor: this.markerState.fill.color,
        fillOpacity: this.markerState.fill.opacity
      });

      if (position === null) {
        var southernPoint = null;
        polyPath.forEach(function (p) {
          if (southernPoint === null || southernPoint.lat > p.lat) {
            southernPoint = p;
          }
        });

        if (southernPoint) {
          this.label = new mapLabel_MapLabel({
            text: title,
            position: new google.maps.LatLng(southernPoint.lat, southernPoint.lng),
            map: visible ? this.map : undefined,
            fontSize: 15,
            align: 'left'
          });
        }
      }
    }
  }

  _createClass(Marker, [{
    key: "remove",
    value: function remove() {
      this.marker.setMap(null);

      if (this.poly != null) {
        this.poly.setMap(null);
      }

      if (this.line != null) {
        this.line.setMap(null);
      }

      if (this.label != null) {
        this.label.setMap(null);
      }
    }
  }, {
    key: "polygonPathFromString",
    value: function polygonPathFromString(pathString) {
      var pairs = pathString.split(",");
      var coords = [];

      for (var i = 0; i < pairs.length; i++) {
        var parts = pairs[i].trim().split(" ");

        if (parts.length === 2) {
          coords.push({
            lat: Number(parts[0]),
            lng: Number(parts[1])
          });
        }
      }

      return coords;
    }
  }, {
    key: "updateVisible",
    value: function updateVisible() {
      if (this.marker != null) {
        var show = this._visible;

        if (this._markerState != null) {
          show = show && !this._markerState.hidden;
        }

        show = show && this._markerTypeVisible;

        if (show) {
          this.marker.setMap(this.map);

          if (this.poly != null) {
            if (this._regionPathVisible) {
              this.poly.setMap(this.map);
            } else {
              this.poly.setMap(null);
            }
          }

          if (this.line) {
            this.line.setMap(this.map);
          }

          if (this.label) {
            this.label.setMap(this.map);
          }
        } else {
          this.marker.setMap(null);

          if (this.poly != null) {
            this.poly.setMap(null);
          }

          if (this.line) {
            this.line.setMap(null);
          }

          if (this.label) {
            this.label.setMap(null);
          }
        }
      }
    }
    /**
     * Draw line to position
     * @param targetPosition Position to draw to
     */

  }, {
    key: "lineTo",
    value: function lineTo(targetPosition) {
      if (this.line) {
        this.line.setMap(null);
      }

      if (targetPosition) {
        var linePath = 'M 0,-1 0,2';
        var lineColor = null;
        var lineOpacity = 0;

        if (this._markerState && this._markerState.line) {
          lineColor = this._markerState.line.color;

          if (this._markerState.line.linePath === "solid") {
            linePath = undefined;
            lineOpacity = 1;
          }
        }

        var lineSymbol = {
          path: linePath,
          strokeOpacity: 0.8,
          scale: 2,
          strokeWeight: 1,
          fillColor: lineColor,
          strokeColor: lineColor
        };
        var markerPosition = this.marker.getPosition();
        this.line = new google.maps.Polyline({
          map: this.map,
          path: [targetPosition, {
            lat: markerPosition.lat(),
            lng: markerPosition.lng()
          }],
          strokeOpacity: lineOpacity,
          strokeWeight: 1,
          strokeColor: lineColor,
          icons: linePath ? [{
            icon: lineSymbol,
            offset: '0',
            repeat: '15px'
          }] : undefined
        });
        this.lineToPosition = targetPosition;
      } else {
        this.lineToPosition = null;
        this.line = null;
      }
    }
    /**
     * Animate marker to new position
     * @param newPosition Position to move marker to
     */

  }, {
    key: "moveTo",
    value: function moveTo(newPosition) {
      var _this2 = this;

      if (this.animationHandler) {
        window.cancelAnimationFrame(this.animationHandler);
      }

      var fromLat = this.marker.getPosition().lat();
      var fromLng = this.marker.getPosition().lng();
      var toLat = newPosition.lat;
      var toLng = newPosition.lng;
      var duration = 1000;
      var startTime = new Date().getTime();
      this.position = newPosition;

      var animateStep = function animateStep() {
        // How far through are we?
        var durationRatio = (new Date().getTime() - startTime) / duration;

        if (durationRatio < 1) {
          // In middle of animation
          var _newPosition = new google.maps.LatLng(fromLat + (toLat - fromLat) * durationRatio, fromLng + (toLng - fromLng) * durationRatio);

          _this2.marker.setPosition(_newPosition);

          if (_this2.line) {
            _this2.line.setPath([_this2.lineToPosition, {
              lat: _newPosition.lat(),
              lng: _newPosition.lng()
            }]);
          }

          _this2.animationHandler = window.requestAnimationFrame(animateStep);
        } else {
          // You have reached your destination
          _this2.marker.setPosition(newPosition);
        }
      };

      animateStep();
    }
  }, {
    key: "state",
    get: function get() {
      return this._state;
    },
    set: function set(newState) {
      if (this._state !== newState) {
        this._state = newState;

        if (!this._state) {
          this.markerState = this.markerType.defaultState;
        } else if (this.markerState) {
          this.markerState = this.markerType.stateGet(this._state);
        }
      }
    }
  }, {
    key: "markerState",
    get: function get() {
      return this._markerState;
    },
    set: function set(newState) {
      var markerVisibleChanged = false;

      if (this._markerState != null && newState != null) {
        var newHidden = newState.hidden == null ? false : newState.hidden;

        if (this._markerState.hidden !== newHidden) {
          markerVisibleChanged = true;
        }
      }

      this._markerState = newState;

      if (this.marker != null) {
        this.marker.setIcon(this.image);

        if (newState) {
          if (newState.opacity !== undefined && newState.opacity !== null) {
            this.marker.setOpacity(newState.opacity);
          } else {
            this.marker.setOpacity(1);
          }
        }
      }

      if (this.poly != null) {
        this.poly.setOptions({
          strokeColor: this._markerState.line.color,
          strokeOpacity: this._markerState.line.opacity,
          strokeWeight: this._markerState.line.weight,
          fillColor: this._markerState.fill.color,
          fillOpacity: this._markerState.fill.opacity
        });
      }

      if (this.line) {
        var lineColor = null;

        if (this._markerState && this._markerState.line) {
          lineColor = this._markerState.line.color;
        }

        var icons = this.line.get("icons");
        icons[0].fillColor = lineColor;
        icons[0].strokeColor = lineColor;
        this.line.set("icons", icons);
        this.line.set("strokeColor", lineColor);
        this.lineTo(this.lineToPosition);
      }

      if (markerVisibleChanged) {
        this.updateVisible();
      }
    }
  }, {
    key: "markerTypeVisible",
    get: function get() {
      return this._markerTypeVisible;
    },
    set: function set(value) {
      this._markerTypeVisible = value;
      this.updateVisible();
    }
  }, {
    key: "visible",
    get: function get() {
      if (!this._visible) {
        return false;
      }

      if (this._markerState != null && this._markerState.hidden) {
        return false;
      }

      if (!this._markerTypeVisible) {
        return false;
      }

      return this._visible;
    },
    set: function set(value) {
      this._visible = value;
      this.updateVisible();
    }
  }, {
    key: "regionPathVisible",
    get: function get() {
      return this._regionPathVisible;
    },
    set: function set(value) {
      this._regionPathVisible = value;
      this.updateVisible();
    }
  }, {
    key: "image",
    get: function get() {
      return this.markerState.imageUrl;
    }
  }, {
    key: "isDraggable",
    get: function get() {
      return this.marker.getDraggable();
    },
    set: function set(value) {
      this.marker.setDraggable(value);
    }
  }, {
    key: "isClickable",
    get: function get() {
      return this.marker.getClickable();
    },
    set: function set(value) {
      this.marker.setClickable(value);
    }
  }]);

  return Marker;
}();
// CONCATENATED MODULE: ./src/scripts/Google/polygon.ts





var polygon_Polygon = /*#__PURE__*/function () {
  function Polygon(map, points, mapLayerItemTypeID, click) {
    _classCallCheck(this, Polygon);

    this.poly = null;
    this.map = map.map;

    if (_typeof(mapLayerItemTypeID) === 'object') {
      this.markerType = mapLayerItemTypeID;
    } else {
      this.markerType = MarkerTypes[mapLayerItemTypeID];
    }

    this.poly = new google.maps.Polygon({
      map: this.map,
      clickable: !!click,
      paths: points,
      strokeColor: this.markerState.line.color,
      strokeOpacity: this.markerState.line.opacity,
      strokeWeight: this.markerState.line.weight,
      fillColor: this.markerState.fill.color,
      fillOpacity: this.markerState.fill.opacity
    });

    if (click) {
      this.poly.addListener("click", function (event) {
        click();
      });
    }
  }

  _createClass(Polygon, [{
    key: "remove",
    value: function remove() {
      this.poly.setMap(null);
    }
  }, {
    key: "markerState",
    get: function get() {
      return this.markerType.defaultState;
    }
  }, {
    key: "editable",
    get: function get() {
      return this.poly.getEditable();
    },
    set: function set(value) {
      this.poly.setEditable(value);
    }
  }]);

  return Polygon;
}();
// CONCATENATED MODULE: ./src/scripts/Google/polyline.ts




var polyline_Polyline = /*#__PURE__*/function () {
  function Polyline(map, points, mapLayerItemTypeID, click) {
    _classCallCheck(this, Polyline);

    this.poly = null;
    this.map = map.map;

    if (_typeof(mapLayerItemTypeID) === 'object') {
      this.markerType = mapLayerItemTypeID;
    } else {
      this.markerType = MarkerTypes[mapLayerItemTypeID];
    }

    this.poly = new google.maps.Polyline({
      map: this.map,
      path: points,
      strokeColor: this.markerState.line.color,
      strokeOpacity: this.markerState.line.opacity,
      strokeWeight: this.markerState.line.weight
    });

    if (click) {
      this.poly.addListener("click", function (event) {
        click();
      });
    }
  }

  _createClass(Polyline, [{
    key: "remove",
    value: function remove() {
      this.poly.setMap(null);
    }
  }, {
    key: "markerState",
    get: function get() {
      return this.markerType.defaultState;
    }
  }, {
    key: "editable",
    get: function get() {
      return this.poly.getEditable();
    },
    set: function set(value) {
      this.poly.setEditable(value);
    }
  }]);

  return Polyline;
}();
// CONCATENATED MODULE: ./src/scripts/Google/layer.ts


var layer_Layer = /*#__PURE__*/function () {
  function Layer(enhancedMapping, mapLayerID, title, boundaries, rotation, imageUrl, minElevation, maxElevation, visible) {
    var _this = this;

    _classCallCheck(this, Layer);

    this.title = "";
    this.rotationValue = 0;
    this.imageDiv = null;
    this.opacity = 1.0;
    this.items = [];
    this.enhancedMapping = enhancedMapping;
    this._visible = visible;
    this.title = title;
    this.minElevation = minElevation;
    this.maxElevation = maxElevation;
    this.imageUrl = imageUrl;
    this.rotationValue = rotation;
    this.boundaries = new google.maps.LatLngBounds({
      lat: boundaries.south,
      lng: boundaries.west
    }, {
      lat: boundaries.north,
      lng: boundaries.east
    });
    this.NEPoint = this.boundaries.getNorthEast();
    this.SWPoint = this.boundaries.getSouthWest();
    this.overlay = new google.maps.OverlayView();

    this.overlay.onAdd = function () {
      return _this.onAdd();
    };

    this.overlay.draw = function () {
      return _this.onDraw();
    };

    this.overlay.onRemove = function () {
      return _this.onRemove();
    };

    this.bounds = this.calculateOverlayBounds(this.NEPoint, this.SWPoint);
    this.overlay.setMap(enhancedMapping.map);
  }

  _createClass(Layer, [{
    key: "remove",
    value: function remove() {
      this.overlay.setMap(null);
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      var _this2 = this;

      if (typeof this.imageUrl !== "undefined" && this.imageDiv === null) {
        // Create the div element that we will be able to rotate
        this.imageDiv = document.createElement("div"); // this.imageDiv.style.border = '3px solid green';

        this.imageDiv.style.position = "absolute";
        this.imageDiv.id = "divOverlayContainer";

        if (this._visible) {
          this.imageDiv.style.visibility = "visible";
        } else {
          this.imageDiv.style.visibility = "hidden";
        } // Create the img element and attach it to the div


        var img = document.createElement("img");

        img.onerror = function (ev) {
          // can't load image (the src provided was invalid)
          var imgLayerImage = document.getElementById("imgLayerImage");

          if (imgLayerImage != null) {
            imgLayerImage.parentNode.removeChild(imgLayerImage);
          }
        };

        img.onload = function (ev) {
          var image = _this2;

          if ("naturalHeight" in image) {
            if (image.naturalHeight + image.naturalWidth === 0) {
              image.onerror(ev);
              return;
            }
          } else if (image.width + image.height === 0) {
            image.onerror(ev);
            return;
          }
        };

        img.id = "imgLayerImage";
        img.src = this.imageUrl;
        img.style.width = "100%";
        img.style.height = "100%";
        img.classList.add("map-layer-image");
        this.imageDiv.appendChild(img);
      }

      this.sendOverlayLayerToBack();
    }
  }, {
    key: "onDraw",
    value: function onDraw() {
      // We use the south-west and north-east
      // coordinates of the overlay to peg it to the correct position and size.
      // To do this, we need to retrieve the projection from the overlay.
      var overlayProjection = this.overlay.getProjection(); // Retrieve the south-west and north-east coordinates of this overlay
      // in LatLngs and convert them to pixel coordinates.
      // We'll use these coordinates to resize the div.

      var sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest());
      var ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast());

      if (this.imageDiv !== null && typeof this.imageDiv !== "undefined") {
        // Resize the image's div to fit the indicated dimensions.
        this.imageDiv.style.left = sw.x + "px";
        this.imageDiv.style.top = ne.y + "px";
        this.imageDiv.style.width = ne.x - sw.x + "px";
        this.imageDiv.style.height = sw.y - ne.y + "px";
        this.imageDiv.style.boxSizing = "content-box";
        this.imageDiv.style.transform = "rotate(" + this.rotationValue + "deg)";
      }
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      if (this.imageDiv !== null) {
        this.imageDiv.parentNode.removeChild(this.imageDiv);
        this.imageDiv = null;
      }
    }
  }, {
    key: "sendOverlayLayerToBack",
    value: function sendOverlayLayerToBack() {
      // Add the element to the correct pane - different when editing or viewing
      var panes = this.overlay.getPanes();

      if (typeof panes !== "undefined") {
        if (this.imageDiv !== null) {
          // In view mode it needs to be in a lower pane to be underneath the markers
          panes.overlayLayer.appendChild(this.imageDiv);
        }
      }
    }
  }, {
    key: "calculateOverlayBounds",
    value: function calculateOverlayBounds(NE, SW) {
      // Calculate the bounds to draw the overlay view to (if the NE and SW parameters are provided, use those)
      var overlayNEPoint;
      var overlaySWPoint;

      if (this.NEPoint === null || typeof this.NEPoint === "undefined" || this.SWPoint === null || typeof this.SWPoint === "undefined") {
        // Get the map on the screen
        var googleMap = this.enhancedMapping.map; // get viewport bounds

        var viewportBounds = googleMap.getBounds(); // Get the viewport NorthEast point

        var viewportNEPoint = {
          lat: viewportBounds.getNorthEast().lat(),
          lng: viewportBounds.getNorthEast().lng()
        }; // Get the viewport SouthWest point

        var viewportSWPoint = {
          lat: viewportBounds.getSouthWest().lat(),
          lng: viewportBounds.getSouthWest().lng()
        }; // Get the center of viewport

        var viewportCenterPoint = {
          lat: googleMap.getCenter().lat(),
          lng: googleMap.getCenter().lng()
        }; // Build a bounds rectangle from the centre of the map to the NorthEast corner of the map

        var NEQuadrantBounds = new google.maps.LatLngBounds();
        NEQuadrantBounds.extend(viewportNEPoint);
        NEQuadrantBounds.extend(viewportCenterPoint); // Get North East quadrant's centre which will be our overlay NE point

        overlayNEPoint = {
          lat: NEQuadrantBounds.getCenter().lat(),
          lng: NEQuadrantBounds.getCenter().lng()
        }; // Build a bounds rectangle from the centre of the map to the SouthWest corner of the map

        var SWQuadrantBounds = new google.maps.LatLngBounds();
        SWQuadrantBounds.extend(viewportSWPoint);
        SWQuadrantBounds.extend(viewportCenterPoint); // Get South West quadrant's centre which will be our overlay SW point

        overlaySWPoint = {
          lat: SWQuadrantBounds.getCenter().lat(),
          lng: SWQuadrantBounds.getCenter().lng()
        };
      } else {
        overlayNEPoint = this.NEPoint;
        overlaySWPoint = this.SWPoint;
      } // Build our overlay object


      return new google.maps.LatLngBounds(overlaySWPoint, overlayNEPoint);
    }
  }, {
    key: "visible",
    get: function get() {
      return this._visible;
    },
    set: function set(value) {
      if (this._visible !== value) {
        this._visible = value;

        if (value) {
          this.overlay.setMap(this.enhancedMapping.map);
        } else {
          this.overlay.setMap(null);
        }
      }
    }
  }]);

  return Layer;
}();
// CONCATENATED MODULE: ./src/scripts/Google/circle.ts


/// <reference types="@types/googlemaps" />
// import { } from 'googlemaps';
var circle_GoogleCircle = /*#__PURE__*/function () {
  function GoogleCircle(enhancedMapping, strokeColor, strokeOpacity, strokeWeight, fillColor, fillOpacity, center, radius, editable) {
    var _this = this;

    _classCallCheck(this, GoogleCircle);

    this.circle = new google.maps.Circle({
      map: enhancedMapping.map,
      strokeColor: strokeColor,
      strokeOpacity: strokeOpacity,
      strokeWeight: strokeWeight,
      fillColor: fillColor,
      fillOpacity: fillOpacity,
      center: center,
      radius: radius,
      editable: editable
    });
    this.circle.addListener("radius_changed", function (event) {
      if (_this.editted) {
        _this.circle.setEditable(false);

        _this.editted(_this.squareBounds);
      }
    });
    this.circle.addListener("center_changed", function (event) {
      if (_this.editted) {
        _this.circle.setEditable(false);

        _this.editted(_this.squareBounds);
      }
    });
  }

  _createClass(GoogleCircle, [{
    key: "remove",
    value: function remove() {
      this.circle.setMap(null);
    }
  }, {
    key: "radius",
    get: function get() {
      return this.circle.getRadius();
    }
  }, {
    key: "squareBounds",
    get: function get() {
      var circleBounds = this.circle.getBounds();
      var ne = circleBounds.getNorthEast();
      var sw = circleBounds.getSouthWest();
      return {
        north: ne.lat(),
        east: ne.lng(),
        south: sw.lat(),
        west: sw.lng()
      };
    }
  }, {
    key: "center",
    get: function get() {
      var center = this.circle.getCenter();
      return {
        lat: center.lat(),
        lng: center.lng()
      };
    },
    set: function set(value) {
      this.circle.setCenter(value);
    }
  }, {
    key: "editable",
    get: function get() {
      return this.circle.getEditable();
    },
    set: function set(value) {
      this.circle.setEditable(value);
    }
  }]);

  return GoogleCircle;
}();
// CONCATENATED MODULE: ./src/scripts/Google/infoWindow.ts


var infoWindow_InfoWindow = /*#__PURE__*/function () {
  function InfoWindow(map, content, position, offset) {
    _classCallCheck(this, InfoWindow);

    this.openOnMap = map;
    this.infoWindow = new google.maps.InfoWindow({
      content: content,
      position: position,
      pixelOffset: new google.maps.Size(offset.width, offset.height)
    });
  }

  _createClass(InfoWindow, [{
    key: "open",
    value: function open() {
      this.infoWindow.open(this.openOnMap.map);
    }
  }, {
    key: "close",
    value: function close() {
      this.infoWindow.close();
    }
  }]);

  return InfoWindow;
}();
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.iterator.js
var es6_string_iterator = __webpack_require__("5df3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__("4f7f");

// CONCATENATED MODULE: ./src/scripts/Google/popup.ts




var popup_Popup = /*#__PURE__*/function () {
  // NOTE: google.maps.OverlayView is only defined once the Maps API has
  // loaded. That is why Popup is defined inside initMap().
  function Popup(position, content, clickEventHandler) {
    var _this = this;

    _classCallCheck(this, Popup);

    this.overlay = new google.maps.OverlayView();

    this.overlay.onAdd = function () {
      return _this.onAdd();
    };

    this.overlay.draw = function () {
      return _this.onDraw();
    };

    this.overlay.onRemove = function () {
      return _this.onRemove();
    };

    this.position = position;
    this.clickEventHandler = clickEventHandler;
    this.content = content.cloneNode(true);
    this.content.classList.add("map-popup-bubble-content"); // This zero-height div is positioned at the bottom of the bubble.

    var bubbleAnchor = document.createElement('div');
    bubbleAnchor.classList.add('popup-bubble-anchor');
    bubbleAnchor.appendChild(content); // This zero-height div is positioned at the bottom of the tip.

    this.containerDiv = document.createElement('div');
    this.containerDiv.classList.add('popup-container');
    this.containerDiv.appendChild(bubbleAnchor); // Optionally stop clicks, etc., from bubbling up to the map.

    this.stopEventPropagation();

    if (clickEventHandler) {
      this.containerDiv.addEventListener("click", function (e) {
        clickEventHandler(e);
      });
    }
  }

  _createClass(Popup, [{
    key: "setMap",
    value: function setMap(map) {
      this.overlay.setMap(map);
    }
  }, {
    key: "getPanes",
    value: function getPanes() {
      return this.overlay.getPanes();
    }
  }, {
    key: "getProjection",
    value: function getProjection() {
      return this.overlay.getProjection();
    }
    /** Called when the popup is added to the map. */

  }, {
    key: "onAdd",
    value: function onAdd() {
      this.getPanes().floatPane.appendChild(this.containerDiv);
    }
    /** Called when the popup is removed from the map. */

  }, {
    key: "onRemove",
    value: function onRemove() {
      if (this.containerDiv.parentElement) {
        this.containerDiv.parentElement.removeChild(this.containerDiv);
      }
    }
    /** Called when the popup needs to draw itself. */

  }, {
    key: "onDraw",
    value: function onDraw() {
      var divPosition = this.getProjection().fromLatLngToDivPixel(this.position); // Hide the popup when it is far out of view.

      var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? "block" : "none";

      if (display === "block") {
        this.containerDiv.style.left = divPosition.x + 'px';
        this.containerDiv.style.top = divPosition.y + 'px';
      }

      if (this.containerDiv.style.display !== display) {
        this.containerDiv.style.display = display;
      }
    }
    /** Stops clicks/drags from bubbling up to the map. */

  }, {
    key: "stopEventPropagation",
    value: function stopEventPropagation() {
      var anchor = this.containerDiv;
      anchor.style.cursor = "auto";
      ["click", "dblclick", "contextmenu", "wheel", "mousedown", "touchstart", "pointerdown"].forEach(function (event) {
        anchor.addEventListener(event, function (e) {
          e.stopPropagation();
        });
      });
    }
  }]);

  return Popup;
}();


// CONCATENATED MODULE: ./src/scripts/Google/clusterer.ts








 /// <reference types="@types/googlemaps" />
// import { } from 'googlemaps';




var clusterer_Clusterer = /*#__PURE__*/function () {
  function Clusterer(map, imagePath) {
    var _this = this;

    _classCallCheck(this, Clusterer);

    this.map = map;
    this.ignoreMarkerTypeIds = new Set();
    var baseLocation = window.location.protocol + "//" + window.location.host + window.location.pathname;
    getScript(baseLocation + "/js/markerclusterer.js").then(function () {
      // @ts-ignore
      _this.markerClustererFar = new MarkerClusterer(_this.map.map, [], {
        maxZoom: 17,
        imagePath: baseLocation + "/images/enhancedmapping/clustering/m"
      }); // @ts-ignore

      _this.markerClustererNear = new MarkerClusterer(_this.map.map, [], {
        maxZoom: 17,
        gridSize: 0.01,
        imagePath: baseLocation + "/images/enhancedmapping/clustering/m"
      });

      _this.map.map.addListener("clusterclick", function (cluster) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (cluster.markerClusterer_ === this.markerClustererNear) {
                    this.createClusterPopup(cluster);
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      });

      _this.map.registerEvent("onDragStart", function () {
        _this.closePopup();
      });
    });
  }

  _createClass(Clusterer, [{
    key: "updateClusters",
    value: function updateClusters(currentMarkers) {
      this.currentMarkers = currentMarkers;
      this.markerClustererFar.clearMarkers();
      this.markerClustererNear.clearMarkers();
      var markers = [];

      for (var layerItemId in currentMarkers) {
        if (currentMarkers.hasOwnProperty(layerItemId)) {
          var layerItem = currentMarkers[layerItemId];
          if (layerItem.visible && !this.ignoreMarkerTypeIds.has(Number(layerItem.mapLayerItemTypeID))) markers.push(layerItem.marker);
        }
      }

      if (this.farCluster) {
        this.markerClustererFar.addMarkers(markers);
      } else {
        this.markerClustererNear.addMarkers(markers);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.markerClustererNear.clearMarkers();
      this.markerClustererFar.clearMarkers();
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      if (this.clusterPopup) {
        this.clusterPopup.setMap(null);
        this.clusterPopup = null;
      }
    }
  }, {
    key: "createClusterPopup",
    value: function createClusterPopup(cluster) {
      var _this2 = this;

      if (this.clusterPopup) {
        this.clusterPopup.setMap(null);
        this.clusterPopup = null;
      }

      var contents = document.createElement("div");
      var contentsList = document.createElement("ul");
      contentsList.classList.add("list-group");
      var closeElement = document.createElement("li");
      closeElement.style.textAlign = "right";
      var closeButtonElement = document.createElement("a");
      closeButtonElement.classList.add("btn");
      closeButtonElement.classList.add("btn-secondary");
      closeButtonElement.style.borderBottomLeftRadius = "0";
      closeButtonElement.style.borderBottomRightRadius = "0";
      closeButtonElement.addEventListener("click", function (e) {
        _this2.closePopup();
      });
      closeElement.appendChild(closeButtonElement);
      var closeButtonIcon = document.createElement("i");
      closeButtonIcon.classList.add("fas");
      closeButtonIcon.classList.add("fa-times");
      closeButtonElement.appendChild(closeButtonIcon);
      contentsList.appendChild(closeElement);
      cluster.markers_.forEach(function (marker) {
        var markerElement = document.createElement("li");
        markerElement.classList.add("list-group-item");
        markerElement.classList.add("list-group-item-action");
        markerElement.classList.add("d-flex");
        markerElement.classList.add("flex-row");
        markerElement.classList.add("p-1");
        markerElement.classList.add("align-items-center");
        markerElement.addEventListener("click", function (e) {
          google.maps.event.trigger(marker, "click");

          _this2.closePopup();
        });
        var markerIconElement = document.createElement("img");
        markerIconElement.classList.add("flex-grow-0");
        markerIconElement.style.transform = "scale(0.7)";
        markerIconElement.src = marker.icon;
        markerElement.appendChild(markerIconElement);
        var markerTitleElement = document.createElement("span");
        markerTitleElement.classList.add("flex-grow-1");
        markerTitleElement.innerText = marker.title;
        markerElement.appendChild(markerTitleElement);
        contentsList.appendChild(markerElement);
      });
      contents.appendChild(contentsList);
      this.clusterPopup = new popup_Popup(cluster.center_, contents, null);
      this.clusterPopup.setMap(this.map.map);
    }
  }, {
    key: "farCluster",
    get: function get() {
      return this._farCluster;
    },
    set: function set(value) {
      this._farCluster = value;
    }
  }]);

  return Clusterer;
}();


// CONCATENATED MODULE: ./src/scripts/Google/heatMap.ts



var heatMap_Heatmap = /*#__PURE__*/function () {
  function Heatmap(enhancedMapping, points) {
    _classCallCheck(this, Heatmap);

    this._bounds = undefined;
    this.map = enhancedMapping;
    this.points = points;
    var heatmapData = points.map(function (p) {
      return new google.maps.LatLng(p.lat, p.lng);
    });
    this.heatMap = new google.maps.visualization.HeatmapLayer({
      data: heatmapData
    });
    this.heatMap.setMap(enhancedMapping.map);
  }

  _createClass(Heatmap, [{
    key: "remove",
    value: function remove() {
      this.heatMap.setMap(null);
    }
  }, {
    key: "bounds",
    get: function get() {
      if (this._bounds !== undefined) return this._bounds;
      return this._bounds = combine(this.points);
    }
  }]);

  return Heatmap;
}();
// CONCATENATED MODULE: ./src/scripts/Google/mapping.ts



























var mapping_GoogleEnhancedMap = /*#__PURE__*/function () {
  function GoogleEnhancedMap(apiKey) {
    _classCallCheck(this, GoogleEnhancedMap);

    this.additionalMaps = [];
    this.additionalMapsInUse = [];
    this.genericInfoWindow = null;
    this.markers = [];
    this.geoObjects = null;
    this._externalMapLayerInfo = [];
    this.key = apiKey;
  }

  _createClass(GoogleEnhancedMap, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("V2Mapping 0.1.37");

                if (window.google.maps) {
                  _context.next = 10;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return getScript("https://maps.googleapis.com/maps/api/js?key=" + "".concat(this.key) + "&libraries=drawing,places,geometry,visualization");

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                console.log(_context.t0);

              case 10:
                this.element = document.createElement("div");
                this.element.classList.add("map-container");
                this.element.style.height = "100%";
                this.map = new map_GoogleMap(this.element, {
                  lat: 0,
                  lng: 0
                }, 2, false, null, null); // setup the default marker types and icons, and go to the DB to get any custom ones.

                _context.next = 16;
                return getMarkerTypes();

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 7]]);
      }));
    }
  }, {
    key: "geoCodeRequest",
    value: function geoCodeRequest(address) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.gpsService) this.gpsService = new gps_service();
                return _context2.abrupt("return", this.gpsService.geoCodeLookup(address, this.key));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "createMap",
    value: function createMap(containerElement, center, zoomLevel, streetView, mapViewType, mapStyles) {
      containerElement.appendChild(this.element);
      this.map.clearEvents();
      this.map.setCursor("grab");
      this.map.center = center;
      this.map.zoom = zoomLevel;
      this.map.mapViewType = mapViewType;
      this.map.mapStyles = mapStyles;
      return this.map;
    }
  }, {
    key: "createMultipleMap",
    value: function createMultipleMap(containerElement, center, zoomLevel, streetView, mapViewType, mapStyles) {
      if (this.additionalMaps.length > 0) {
        var poppedElement = this.additionalMaps.pop();
        containerElement.appendChild(poppedElement.element);
        poppedElement.map.clearEvents();
        poppedElement.map.setCursor("grab");
        poppedElement.map.center = center;
        poppedElement.map.zoom = zoomLevel;
        poppedElement.map.mapViewType = mapViewType;
        poppedElement.map.mapStyles = mapStyles;
        this.additionalMapsInUse.push(poppedElement);
        return poppedElement.map;
      }

      var element = document.createElement("div");
      element.classList.add("map-container");
      element.style.height = "100%";
      containerElement.appendChild(element);
      var map = new map_GoogleMap(element, center, zoomLevel, false, mapViewType, mapStyles);
      var newMapAndElement = {
        element: element,
        map: map
      };
      this.additionalMapsInUse.push(newMapAndElement);
      return newMapAndElement.map;
    }
  }, {
    key: "releaseMultipleMap",
    value: function releaseMultipleMap(map) {
      var inUseIndex = this.additionalMapsInUse.findIndex(function (m) {
        return m.map === map;
      });

      if (inUseIndex > -1) {
        var inUseMap = this.additionalMapsInUse[inUseIndex];
        this.additionalMapsInUse.splice(inUseIndex, 1);
        this.additionalMaps.push(inUseMap);
      }
    }
  }, {
    key: "createMarker",
    value: function createMarker(enhancedMapping, mapLayerItemId, eventRecordId, mapLayerItemTypeId, objectId, title, position, regionPath, minElevation, maxElevation, visible) {
      return new marker_Marker(enhancedMapping, mapLayerItemId, eventRecordId, mapLayerItemTypeId, objectId, title, position, regionPath, minElevation, maxElevation, visible);
    }
  }, {
    key: "createPolyline",
    value: function createPolyline(enhancedMapping, points, mapLayerItemTypeID, click) {
      return new polyline_Polyline(enhancedMapping, points, mapLayerItemTypeID, click);
    }
  }, {
    key: "createPolygon",
    value: function createPolygon(enhancedMapping, points, mapLayerItemTypeID, click) {
      return new polygon_Polygon(enhancedMapping, points, mapLayerItemTypeID, click);
    }
  }, {
    key: "createOverlay",
    value: function createOverlay(enhancedMapping, mapLayerId, title, boundaries, rotation, imageUrl, minElevation, maxElevation, visible) {
      return new layer_Layer(enhancedMapping, mapLayerId, title, boundaries, rotation, imageUrl, minElevation, maxElevation, visible);
    }
  }, {
    key: "createHeatmap",
    value: function createHeatmap(enhancedMapping, points) {
      return new heatMap_Heatmap(enhancedMapping, points);
    }
  }, {
    key: "createCircle",
    value: function createCircle(enhancedMapping, strokeColor, strokeOpacity, strokeWeight, fillColor, fillOpacity, center, radius, editable) {
      return new circle_GoogleCircle(enhancedMapping, strokeColor, strokeOpacity, strokeWeight, fillColor, fillOpacity, center, radius, editable);
    }
  }, {
    key: "createClusterer",
    value: function createClusterer(map, imagePath) {
      return new clusterer_Clusterer(map, imagePath);
    }
  }, {
    key: "createKmlLayer",
    value: function createKmlLayer(externalMapLayerItem) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        var url, layer, clickHandler, clickHandlerClass, customClickHandler;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // set the data object url from the parameters
                url = this.getKmlParamsURL(externalMapLayerItem);
                externalMapLayerItem.dataObjectURL = externalMapLayerItem.url; // create a new kml layer pointing at our source

                layer = new google.maps.KmlLayer({
                  url: url,
                  preserveViewport: true,
                  // suppress the default info window dataObjectURL is set and we are loading data from a custom url
                  suppressInfoWindows: externalMapLayerItem.dataObjectURL && externalMapLayerItem.dataObjectURL.length > 0
                }); // set the click handler to use the generic one, if a custom one is set, and can be loaded correctly it will overrite this

                clickHandler = this.getKmlItemDetails; // if a custom click handler has been set for this layer

                if (!externalMapLayerItem.customClickHandler) {
                  _context4.next = 20;
                  break;
                }

                _context4.prev = 5;
                _context4.next = 8;
                return import(
                /* webpackIgnore: true */
                "".concat("/immixcc/plugins", "/External Map Layers/").concat(externalMapLayerItem.customClickHandler, ".js"));

              case 8:
                clickHandlerClass = _context4.sent;
                // create a new instance of the click handler class
                customClickHandler = new clickHandlerClass.default();

                if (!(typeof customClickHandler.onClick == "function")) {
                  _context4.next = 14;
                  break;
                }

                // assign our click handler to the onClick method
                clickHandler = customClickHandler.onClick;
                _context4.next = 15;
                break;

              case 14:
                throw "onClick method for click handler ".concat(externalMapLayerItem.customClickHandler, " not found");

              case 15:
                _context4.next = 20;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](5);
                console.error("Error loading click handler for '".concat(externalMapLayerItem.title, "' layer. ").concat(_context4.t0));

              case 20:
                if (typeof layer.addListener === "function") {
                  // hook up the click handler to the click event passing the layer details and map
                  layer.addListener("click", function (event) {
                    return __awaiter(_this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                      return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              // close any other info windows
                              this.closeInfoWindow();
                              _context3.next = 3;
                              return clickHandler(event, externalMapLayerItem, this.map.map);

                            case 3:
                              this.genericInfoWindow = _context3.sent;

                            case 4:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3, this);
                    }));
                  });
                }

                return _context4.abrupt("return", layer);

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 17]]);
      }));
    }
  }, {
    key: "getKmlParamsURL",
    value: function getKmlParamsURL(externalMapLayer) {
      var fullURL = externalMapLayer.url; // If layer is not an ArcGIS layer just return the regular url

      if (externalMapLayer.externalMapLayerTypeID !== 3) {
        return fullURL;
      }

      var params = [];

      if (externalMapLayer.parameters && externalMapLayer.parameters.length > 0) {
        // for each filter parameter build a coresponding string to represent it in the query
        for (var _i = 0, _Object$entries = Object.entries(externalMapLayer.parameters); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          // if the type is an object, then it is an array of ids
          if (_typeof(value) === "object") {
            // If value isntnull or whitespace
            if (externalMapLayer.parameters[key].defaultValue) {
              params.push(encodeURI("".concat(externalMapLayer.parameters[key].title.toLowerCase(), "='").concat(externalMapLayer.parameters[key].defaultValue, "'")));
            }
          } else {
            params.push();
          }
        }
      } // if we have no parameters add 'where="1=1"' to retrieve all


      if (params == null || params.length < 1) {
        params.push("1%3D1");
      } // combine the url, item filter parameters and the data format parameters together


      fullURL = "".concat(fullURL, "/query?where=").concat(params.join("&"), "&outFields=%5B\"*\"%5D&f=kmz&rnd=").concat(new Date().getUTCMilliseconds());
      return fullURL;
    }
  }, {
    key: "closeInfoWindow",
    value: function closeInfoWindow() {
      if (this.genericInfoWindow) {
        try {
          this.genericInfoWindow.close();
        } catch (err) {
          console.log("Error closing infoWindows : ".concat(err));
        }
      }
    }
  }, {
    key: "clearMarkers",
    value: function clearMarkers() {
      // Clear down of geoJSON object
      if (this.geoObjects) {
        if (this.geoObjects.length > 0) {
          for (var i = 0; i < this.geoObjects.length; i++) {
            this.map.map.data.remove(this.geoObjects[i]);
          }

          this.geoObjects = [];
        }
      } // Clear down of markers


      if (this.markers && this.markers.length > 0) {
        this.markers.forEach(function (marker) {
          marker.setMap(null);
        });
        this.markers = [];
      }
    }
  }, {
    key: "getKmlItemDetails",
    value: function getKmlItemDetails(kmlMouseEvent, externalMapLayer, map) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var dataToParse, kmlObjectId, matchType, match0, match1, infoWindowContent, requestUrl, result, features, infowindow;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dataToParse = null;
                kmlObjectId = "0"; // check that the kmlMouseEvent is set and we have a url to get data from

                if (!(kmlMouseEvent && externalMapLayer.dataObjectURL && externalMapLayer.dataObjectURL.length > 0)) {
                  _context5.next = 22;
                  break;
                }

                if (!kmlMouseEvent.featureData) {
                  _context5.next = 22;
                  break;
                }

                // try and find a property that contains the ObjectID so we can extract it
                matchType = 0;

                if (kmlMouseEvent.featureData.description.toLowerCase().includes("objectid")) {
                  dataToParse = kmlMouseEvent.featureData.description;
                } else if (kmlMouseEvent.featureData.infoWindowHtml.toLowerCase().includes("objectid")) {
                  dataToParse = kmlMouseEvent.featureData.infoWindowHtml;
                } else if (kmlMouseEvent.featureData.snippet.toLowerCase().includes("objectid")) {
                  dataToParse = kmlMouseEvent.featureData.snippet;
                } // @todo - try and find object_id too - this should be done better!!


                if (kmlMouseEvent.featureData.description.toLowerCase().includes("object_id")) {
                  dataToParse = kmlMouseEvent.featureData.description;
                  matchType = 1;
                } else if (kmlMouseEvent.featureData.infoWindowHtml.toLowerCase().includes("object_id")) {
                  dataToParse = kmlMouseEvent.featureData.infoWindowHtml;
                  matchType = 1;
                } else if (kmlMouseEvent.featureData.snippet.toLowerCase().includes("object_id")) {
                  dataToParse = kmlMouseEvent.featureData.snippet;
                  matchType = 1;
                }

                if (dataToParse != null) {
                  if (matchType == 0) {
                    // try and extract the ObjectID from the string
                    match0 = /(?:objectid.*?)(\d+)/gi.exec(dataToParse);
                    kmlObjectId = match0[1];
                  } else {
                    match1 = /(?:object_id.*?)(\d+)/gi.exec(dataToParse);
                    kmlObjectId = match1[1];
                  }
                }

                infoWindowContent = ""; // if we have an object to go and find

                if (!(kmlObjectId != "0")) {
                  _context5.next = 17;
                  break;
                }

                // make request to get additional data
                requestUrl = "".concat(externalMapLayer.dataObjectURL, "/query?objectIds=").concat(kmlObjectId, "=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&having=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&f=pjson");
                _context5.next = 13;
                return external_axios_default.a.get(requestUrl);

              case 13:
                result = _context5.sent;

                // if our result is defined and has a features property
                if (result.data && result.data.features) {
                  features = result.data.features;
                  infoWindowContent = "<table>"; // iterate over each feature's attributes property

                  features.forEach(function (feature, index) {
                    if ("attributes" in feature) {
                      // build the HTML table using the value if it is not null
                      for (var _i2 = 0, _Object$entries2 = Object.entries(feature["attributes"]); _i2 < _Object$entries2.length; _i2++) {
                        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                            key = _Object$entries2$_i[0],
                            value = _Object$entries2$_i[1];

                        if (value != null) {
                          infoWindowContent += "<tr><td>".concat(key, ":<td><td> ").concat(value, "</td></tr>");
                        }
                      }
                    }
                  });
                  infoWindowContent += "</table>";
                }

                _context5.next = 19;
                break;

              case 17:
                console.error("Could not find ObjectID for KML Item " + kmlMouseEvent.featureData.name);
                infoWindowContent = kmlMouseEvent.featureData.infoWindowHtml;

              case 19:
                // define infoWindow object
                infowindow = new google.maps.InfoWindow({
                  content: infoWindowContent,
                  position: kmlMouseEvent.latLng,
                  pixelOffset: kmlMouseEvent.pixelOffset
                });

                if (typeof infowindow.open === "function") {
                  infowindow.open(map);
                }

                return _context5.abrupt("return", infowindow);

              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
  }, {
    key: "createImageMapLayer",
    value: function createImageMapLayer(mapLayerItem) {
      // this is probably a hacky solution - may need to find a better one!
      var tileUrlFunction = function tileUrlFunction(tile, zoom) {
        var extent = [-Math.PI * 6378137, Math.PI * 6378137];
        var x = tile.x;
        var y = tile.y;
        var z = zoom;
        var tileSize = extent[1] * 2 / Math.pow(2, z);
        var minx = extent[0] + x * tileSize;
        var maxx = extent[0] + (x + 1) * tileSize; // remember y origin starts at top

        var miny = extent[1] - (y + 1) * tileSize;
        var maxy = extent[1] - y * tileSize;
        var bbox = [minx, miny, maxx, maxy];
        return mapLayerItem.url + "&BBOX=" + bbox.join(",") + "&WIDTH=256&HEIGHT=256";
      };

      var imageMap = new google.maps.ImageMapType({
        getTileUrl: tileUrlFunction,
        tileSize: new google.maps.Size(256, 256),
        opacity: 0.6,
        name: mapLayerItem.title,
        minZoom: 0,
        maxZoom: 19
      });
      return imageMap;
    }
  }, {
    key: "displayExternalMapLayer",
    value: function displayExternalMapLayer(mapLayerItem, currentGoogleMap) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var layer;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.t0 = mapLayerItem.externalMapLayerTypeID;
                _context6.next = _context6.t0 === 1 ? 4 : _context6.t0 === 3 ? 4 : _context6.t0 === 2 ? 8 : _context6.t0 === 4 ? 12 : _context6.t0 === 5 ? 12 : 15;
                break;

              case 4:
                _context6.next = 6;
                return this.createKmlLayer(mapLayerItem);

              case 6:
                layer = _context6.sent;
                return _context6.abrupt("break", 15);

              case 8:
                if (!currentGoogleMap.data) {
                  _context6.next = 11;
                  break;
                }

                _context6.next = 11;
                return this.plotGeoJSON(currentGoogleMap, mapLayerItem);

              case 11:
                return _context6.abrupt("break", 15);

              case 12:
                layer = this.createImageMapLayer(mapLayerItem);

                if (currentGoogleMap.overlayMapTypes) {
                  currentGoogleMap.overlayMapTypes.setAt(0, layer);
                }

                return _context6.abrupt("break", 15);

              case 15:
                if (layer && layer !== null && typeof layer.setMap === "function") {
                  layer.setMap(currentGoogleMap);
                }

                _context6.next = 21;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t1 = _context6["catch"](0);
                console.log(_context6.t1);

              case 21:
                return _context6.abrupt("return", layer);

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 18]]);
      }));
    }
  }, {
    key: "plotGeoJSON",
    value: function plotGeoJSON(currentGoogleMap, mapLayerItem) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this2 = this;

        var geoJson, collection;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getGeoJsonFromUrl(mapLayerItem.url);

              case 2:
                geoJson = _context7.sent;

                // Work out what points to plot depending on whose url it is
                if (mapLayerItem.url.includes("DownloadReportGeoJSON")) {
                  // Plot markers from internal source
                  collection = geoJson; // iterate over each feature's properties

                  collection.features.forEach(function (feature, index) {
                    // Creates new maker
                    var marker = new google.maps.Marker({
                      position: new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]),
                      map: currentGoogleMap
                    }); // Add a count label to the marker if it exists

                    if (feature.properties.hasOwnProperty("Count")) {
                      marker.set("label", feature.properties["Count"]);
                    } // Add the marker to the list of all markers


                    _this2.markers.push(marker); // Assign the infowindow to the marker click event


                    marker.addListener("click", function () {
                      _this2.closeInfoWindow(); // Creates a table of the feature contents for displaying in an infowindow


                      var infoWindowContent = "<table>";

                      if ("properties" in feature) {
                        // build the HTML using the values in the features properties
                        for (var _i3 = 0, _Object$entries3 = Object.entries(feature["properties"]); _i3 < _Object$entries3.length; _i3++) {
                          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
                              key = _Object$entries3$_i[0],
                              value = _Object$entries3$_i[1];

                          if (value != null) {
                            infoWindowContent += "<tr><td><b>".concat(key, ":</b><td><td> ").concat(value, "</td></tr>");
                          }
                        }
                      }

                      if ("geometry" in feature) {
                        //Add the lat long of the merker at the end
                        infoWindowContent += "<tr><td>latLong:<td><td> ".concat(feature.geometry.coordinates, "</td></tr>");
                      }

                      infoWindowContent += "</table>"; // // Create info window

                      _this2.genericInfoWindow = new google.maps.InfoWindow({
                        content: infoWindowContent
                      }); // Open info window

                      _this2.genericInfoWindow.open(currentGoogleMap, marker);
                    });
                  });
                } else {
                  // Plot objects from external sources as usual
                  this.geoObjects = currentGoogleMap.data.addGeoJson(geoJson);
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getGeoJsonFromUrl",
    value: function getGeoJsonFromUrl(url) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var axiosInstance, windowAxios, result;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                axiosInstance = external_axios_default.a;
                windowAxios = window["axios.instance"];

                if (url.includes("DownloadReportGeoJSON") && windowAxios && windowAxios.axiosInstance) {
                  axiosInstance = windowAxios.axiosInstance;
                }

                _context8.next = 5;
                return axiosInstance.get(url);

              case 5:
                result = _context8.sent;
                return _context8.abrupt("return", result.data);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
  }, {
    key: "hideExternalMapLayer",
    value: function hideExternalMapLayer(mapLayerItem) {
      if (!this._externalMapLayerInfo) {
        this._externalMapLayerInfo = [];
      }

      var existingInfo = this._externalMapLayerInfo[mapLayerItem.externalMapLayerID];

      if (existingInfo && existingInfo.layer) {
        // check to see if we currently have a layer for this type
        if (existingInfo.layer) {
          // remove it from the map
          if (typeof existingInfo.layer.setMap === "function") {
            existingInfo.layer.setMap(null);
          } // destroy it


          existingInfo.layer = null; // remove all reference to it

          this._externalMapLayerInfo[mapLayerItem.externalMapLayerID] = null;
        }
      } // close genericInfoWindow


      this.closeInfoWindow(); // clear markers

      this.clearMarkers();
    }
  }, {
    key: "loadExternalMapLayers",
    value: function loadExternalMapLayers(mapLayers, currentGoogleMap) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                mapLayers.forEach(function (layer) {
                  return __awaiter(_this3, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                    var existingInfo, layerInfo, infoObject;
                    return regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            if (!layer) {
                              _context9.next = 19;
                              break;
                            }

                            _context9.prev = 1;

                            if (!(layer.displaying === true)) {
                              _context9.next = 13;
                              break;
                            }

                            if (!this._externalMapLayerInfo) {
                              this._externalMapLayerInfo = [];
                            }

                            existingInfo = this._externalMapLayerInfo[layer.externalMapLayerID];

                            if (existingInfo && existingInfo.layer && existingInfo.layer !== null) {
                              // check to see if we currently have a layer for this type
                              if (typeof existingInfo.layer.setMap === "function") {
                                existingInfo.layer.setMap(currentGoogleMap);
                              } // instead call unload layers


                              this.hideExternalMapLayer(layer);
                            } // create a object to maintain layer info


                            _context9.next = 8;
                            return this.displayExternalMapLayer(layer, currentGoogleMap);

                          case 8:
                            layerInfo = _context9.sent;
                            infoObject = {
                              layer: layerInfo
                            };
                            this._externalMapLayerInfo[layer.externalMapLayerID] = infoObject;
                            _context9.next = 14;
                            break;

                          case 13:
                            this.hideExternalMapLayer(layer);

                          case 14:
                            _context9.next = 19;
                            break;

                          case 16:
                            _context9.prev = 16;
                            _context9.t0 = _context9["catch"](1);
                            console.log(_context9.t0);

                          case 19:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9, this, [[1, 16]]);
                  }));
                });

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
    }
  }, {
    key: "unloadExternalMapLayers",
    value: function unloadExternalMapLayers(mapLayers) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                mapLayers.forEach(function (layer) {
                  return __awaiter(_this4, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                    return regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            // if this item isnt an object, do nothing.
                            if (layer) {
                              this.hideExternalMapLayer(layer);
                            }

                          case 1:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, this);
                  }));
                });

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
    }
  }, {
    key: "createInfoWindow",
    value: function createInfoWindow(map, content, position, offset) {
      return new infoWindow_InfoWindow(map, content, position, offset);
    }
  }]);

  return GoogleEnhancedMap;
}();


// CONCATENATED MODULE: ./src/scripts/Mapping.ts





var Mapping_MappingInstance = function MappingInstance() {
  _classCallCheck(this, MappingInstance);
};

var currentMappingInstance = {};
function getEnhancedMapping(type, apiKey) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var typeValue, googleMap;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!currentMappingInstance[type]) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", currentMappingInstance[type]);

          case 2:
            typeValue = type.toLowerCase();
            _context.t0 = typeValue;
            _context.next = _context.t0 === "google" ? 6 : 11;
            break;

          case 6:
            googleMap = new mapping_GoogleEnhancedMap(apiKey);
            _context.next = 9;
            return googleMap.init();

          case 9:
            currentMappingInstance[typeValue] = googleMap;
            return _context.abrupt("return", googleMap);

          case 11:
            return _context.abrupt("return", null);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
// CONCATENATED MODULE: ./src/scripts/Types.ts





// Class that handles converting ArcGis Fields
var Types_ExternalMapLayerParameter = /*#__PURE__*/function () {
  function ExternalMapLayerParameter() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var externalMapLayerId = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, ExternalMapLayerParameter);

    this.externalMapLayerParameterId = 0;
    this.externalMapLayerId = 0;
    this.title = "";
    this.defaultValue = "";
    this.isVisible = true;
    this.type = "";

    if (properties) {
      this.title = this.checkNameOrTitle(properties);
      this.externalMapLayerId = externalMapLayerId;
      this.defaultValue = this.setDefaultValue(properties);
      this.type = properties.type;
    }
  } // Check the properties object for the appropriate field to assign to title


  _createClass(ExternalMapLayerParameter, [{
    key: "checkNameOrTitle",
    value: function checkNameOrTitle(properties) {
      if (properties.hasOwnProperty("name")) {
        return properties.name;
      } else if (properties.hasOwnProperty("alias")) {
        return properties.alias;
      } else return "";
    } // Sets an appropriate default value

  }, {
    key: "setDefaultValue",
    value: function setDefaultValue(properties) {
      if (properties.type.includes("integer" || false)) {
        return "0";
      } else if (properties.type.includes("float")) {
        return "0.0";
      } else return "";
    }
  }]);

  return ExternalMapLayerParameter;
}();
// CONCATENATED MODULE: ./src/index.js










// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ }),

/***/ "fdef":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "ffc1":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("5ca1");
var $entries = __webpack_require__("504c")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ })

/******/ });
//# sourceMappingURL=V2Mapping.common.js.map